import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import {
  IconButton,
  Link as MaterialLink,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { FormErrors } from "../../../components/Login/FormErrors";
import { userService } from "_services/user.service";
import enMsg from "__helpers/locale/en/en";
import PhoneNumber from "awesome-phonenumber";
import ConfirmModal from "components/Modal/modal";
import Icon from "@material-ui/core/Icon";
import PatientIcon from "assets/img/icons/patient-icon.svg";
import PatientDateIcon from "assets/img/icons/patient-date-icon.svg";
import PatientDepartmentIcon from "assets/img/icons/patient-department-icon.svg";
import CrownIcon from "assets/img/icons/crown.svg";
import DownloadIcon from "assets/img/icons/download-icon.svg";
import EyeIcon from "assets/img/icons/eye-icon.svg";
import FileIcon from "assets/img/icons/file-icon.svg";
import DownloadIconGray from "assets/img/icons/download-icon-gray.svg";
import EyeIconGray from "assets/img/icons/eye-icon-gray.svg";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { apiPath } from "api";
import {
  generalAuthTokenHeader,
  multimediaAuthTokenHeader,
} from "__helpers/auth-header";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  TablePagination,
} from "@material-ui/core";
import { DEFAULT_PER_PAGE_RECORDS, REFERRAL_STATUS, getStatusDisplayLabel } from "__helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Slide,
  Menu,
} from "@material-ui/core";
import SelectStatus from "components/SelectStatus/selectStatus";
import CircularProgress from "@material-ui/core/CircularProgress";
import { basePath, baseRoutes, dpBaseRoutes } from "base-routes";
import { FormGroup, FormControl, InputLabel } from "@material-ui/core";
import { Link } from "react-router-dom";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import { PATIENT_SORT, PATIENT_FILTER } from "__helpers/constants";
import done from "assets/img/done.svg";

import Container from "@material-ui/core/Container";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Checkbox from "@material-ui/core/Checkbox";
import logo from "assets/img/front-logo.png";
import ScrollMenu from "react-horizontal-scrolling-menu";
import InfiniteScroll from "react-infinite-scroller";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { connect } from "react-redux";
import { reduxLoad } from "js/actions/index";

import Chip from "@material-ui/core/Chip";
import CircleChecked from "@material-ui/icons/CheckCircleOutline";
import CircleCheckedFilled from "@material-ui/icons/CheckCircle";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";

import leftArrow from "assets/img/icons/arrorw1.svg";
import rightArrow from "assets/img/icons/arrow2.svg";
import { ALLOWED_PROFILE_IMAGE_SIZE } from "__helpers/constants";
import { ALLOWED_IMAGE_EXTENTION } from "__helpers/constants";
import fileExtension from "file-extension";
import infoIcon from "assets/img/icons/info-icon.svg";
import tasksImg from "assets/img/icons/tasksImg.png";
import { REDUX_STATE_DATA } from "__helpers/constants";

// own carosoul
// import React from 'react';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { PATIENT_LIST, MAX_INPUT_LENGTH_LONG } from "__helpers/constants";
import { USER_INFO } from "__helpers/constants";
import ChangePassword from "views/Profile/ChangePassword";
import { Scrollbars } from "react-custom-scrollbars";
import { formatDateToLocalFormat } from "__helpers/util";
import ChatBubbleOutlineRoundedIcon from "@material-ui/icons/ChatBubbleOutlineRounded";
import "./providerPatientDashboard.css";
import Grid from "@material-ui/core/Grid";
import commentIcon from "assets/img/icons/comment.svg";

import ProviderCommentModal from "views/providerViews/PatientDashboard/providerCommentModal";
import ContentViewerPanel from "views/providerViews/PatientDashboard/ContentViewerPanel";
import PatientTabs from "components/PatientTabs";
import Comment from "components/Comments/Comment";
import update from "immutability-helper"; // ES6

import moment from "moment-timezone";
import BAAComponent from "views/CmsPages/BAAComponent";
import TermsComponent from "views/CmsPages/TermsComponent";
import { providerBaseRoutes } from "base-routes";
import { REFERRAL_TYPE } from "__helpers/constants";
import { REFERRAL_TYPES } from "__helpers/constants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import EventIcon from "@material-ui/icons/Event";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FilterListIcon from "@material-ui/icons/FilterList";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { CenterFocusStrong } from "@material-ui/icons";
import { textAlign } from "@material-ui/system";

function mapDispatchToProps(dispatch) {
  return {
    reduxLoad: (reduxLoadVal) => dispatch(reduxLoad(reduxLoadVal)),
  };
}

const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const AddOrRemove = "Add";

moment.tz.setDefault("UTC");
const CategotyMenuItem = ({ keyVals, cListVals }) => {
  const { masterCategories, catagoryId, status } = cListVals;
  return (
    <Box className="item menu-item" key={keyVals} border={1}>
      <p className="category-value">{masterCategories.categoryValue}</p>
      <p className="category-status">{masterCategories.status}Awaiting</p>
    </Box>
  );
};

export const CategotyMenu = (list, selected, categoryList) =>
  list.map((el, key) => {
    const { name } = el;

    return (
      <CategotyMenuItem
        cListVals={el}
        text={name}
        key={key}
        selected={selected}
        categoryList={categoryList}
      />
    );
  });

const CategotyArrow = ({ text, className }) => {
  return (
    <div className={className}>
      <img src={text} />
    </div>
  );
};

const ArrowLeft = CategotyArrow({ text: leftArrow, className: "arrow-prev" });
const ArrowRight = CategotyArrow({ text: rightArrow, className: "arrow-next" });

const selected = "item1";
const options = {
  items: 3,
  nav: true,
  rewind: true,
  autoplay: false,
};

const date = new Date();
const offset = date.getTimezoneOffset();

const getFormattedAddress = (address) => {
  if (address) {
    const addressObject = JSON.parse(address);
    return addressObject.formatted_address || addressObject.address;
  }
};

class PatientListClass extends React.Component {
  inputOpenImageFileRef = React.createRef(null);
  inputOpenFaceSheetFileRef = React.createRef(null);
  maxDate = new Date();
  minDate = new Date();
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    // let patientList = JSON.parse(localStorage.getItem(PATIENT_LIST));
    const patientCategoryList = ["1", "3"];
    this.dateUtility = new DateFnsUtils();
    this.patientImageName = "";
    this.patientImageBlob = null;
    this.patientFaceSheetName = "";
    this.patientFaceSheetBlob = null;
    this.state = {
      loading: false,
      referralActionModalStatus: false,
      acceptedReferralModalStatus: false,
      providerCommentModalStatus: false,
      perPage: DEFAULT_PER_PAGE_RECORDS,
      total: 0,
      selectionCount: 0,
      currentPage: 0,
      totalPatientShowing: 0,
      sorting: "desc",
      filter: "createdDateTime",
      loadingPatient: true,
      loadingState: false,
      items: 10,
      patientSearchKeyword: "",
      direction: true, //true means asc and false means desc
      spinner: spinner,
      declineReason: "",
      formErrors: {
        declineReason: "",
        commentToDP: "",
      },
      declineReasonValid: false,
      patientName: "unknown",
      selectedPatientId: "",
      patientCategoryList: [],
      patientList: [],
      categoryList: props.categoryListRedux ? props.categoryListRedux : [],
      insuranceList: props.insuranceListRedux ? props.insuranceListRedux : [],
      hospitalList: props.hospitalListRedux ? props.hospitalListRedux : [],
      patientStatusList: props.patientStatusListRedux
        ? props.patientStatusListRedux
        : [],
      userInfo: props.userInfoRedux ? props.userInfoRedux : {},
      loadMore: false,
      estDate: null,
      patientCategories: [],
      reduxLoadFlag: false,
      patientTaskCount: 0,
      loadPatient: true,
      selectedPatientData: "",
      selectedPatientCategoryValue: "",
      selectedPatientHospitalValue: "",
      selectedPatientInsuranceValue: "",
      referralStatusIds: [1, 3, 5, 6, 7, 9],
      canAcceptComment: "",
      confirmModalStatus: false,
      confirmModalMessage: "",
      openModal: false,
      bbaCondition: false,
      termNcondition: false,
      searchCriteria: "",
      patientListSeletedIndex: "",
      selectRererralId: "",
      selectRererralItemId: "",
      commentToDP: "",
      commentToDPValid: "",
      isPrelimCommentDone: false,
      prelimCommentByProvider: "",
      commentPostReferralId: "",
      commentsThread: [],
      selectedPatientKey: "",
      confirmBoxStatus: false,
      filterList: [],
      filterby: "",
      filterbyinsuranceId: "",
      selectedcomment: "",
      // Content Viewer State
      contentViewerOpen: false,
      viewerContent: "",
      viewerContentType: "", // 'html', 'pdf', 'image', 'docx'
      viewerFileName: "",
      loadingViewer: false,
      documentList: [], // List of documents from patientUploadHistory
      // Mobile popup states (separate from desktop contentViewerOpen)
      mobileReferralPopupOpen: false, // First popup - referral detail
      mobileContentViewerOpen: false, // Second popup - documents & AI insights
      mobileFiltersOpen: false, // Mobile filters dropdown toggle
      // Tooltip states for mobile touch support
      tooltipSearchOpen: false,
      tooltipPreliminaryOpen: false,
      tooltipAIInsightsOpen: false,
      exportMenuAnchor: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchPatients = this.fetchPatients.bind(this);
    this.search = this.search.bind(this);
    this.searchReturn = this.searchReturn.bind(this);
    this.loadMorePatient = this.loadMorePatient.bind(this);
    this.handlePatientSorting = this.handlePatientSorting.bind(this);

    this.getPatientHospitalName = this.getPatientHospitalName.bind(this);
    this.declineFormSubmit = this.declineFormSubmit.bind(this);
    this.acceptReferral = this.acceptReferral.bind(this);
    this.handleBAAAgree = this.handleBAAAgree.bind(this);
    this.handleTNCAgree = this.handleTNCAgree.bind(this);
    this.fetchFilter = this.fetchFilter.bind(this);
  }
  componentDidMount() {
    this.props.reduxLoad(false);
    let user = JSON.parse(localStorage.getItem(USER_INFO));
    if (!user.termNcondition) {
      this.setState({
        openModal: false,
        termNcondition: true,
        bbaCondition: false,
      });
    } else if (!user.termNcondition) {
      this.setState({
        openModal: false,
        termNcondition: false,
        bbaCondition: true,
      });
    } else {
      if (user.newUser) {
        this.setState({
          openModal: true,
          termNcondition: false,
          bbaCondition: false,
        });
      } else {
        this.setState({
          openModal: false,
          termNcondition: false,
          bbaCondition: false,
        });
      }
    }
    if (this.state.patientList && this.state.patientList.length == 0) {
      this.fetchPatients();
    }

    if (user.bbaCondition && user.termNcondition) {
      console.log("ccc");
      this.fetchPage();
      this.fetchFilter();
    }

    var p = [-10, 200, 100000, -50, 5000];
  }
  handleBAAAgree() {
    let user = JSON.parse(localStorage.getItem(USER_INFO));
    user.termNcondition = true;
    user.bbaCondition = true;
    localStorage.setItem(USER_INFO, JSON.stringify(user));
    if (user.newUser) {
      this.setState({
        openModal: true,
        termNcondition: false,
        bbaCondition: false,
      });
    } else {
      this.setState({
        openModal: false,
        termNcondition: false,
        bbaCondition: false,
      });
    }
  }
  handleTNCAgree() {
    this.setState({
      openModal: false,
      termNcondition: false,
      bbaCondition: true,
    });
  }
  componentDidUpdate() {
    if (
      this.props.reduxLoadFlag != undefined &&
      this.state.reduxLoadFlag != this.props.reduxLoadFlag &&
      this.props.hospitalListRedux &&
      this.props.hospitalListRedux.length > 0
    ) {
      let categoryList = [];
      let insuranceList = [];
      let hospitalList = [];
      let patientStatusList = [];
      let userInfo = {};
      if (this.props.categoryListRedux) {
        let selectedcategoryList = this.props.categoryListRedux;
        categoryList = selectedcategoryList ? selectedcategoryList : [];
      }
      if (this.props.insuranceListRedux) {
        let selectedinsuranceList = this.props.insuranceListRedux;
        insuranceList = selectedinsuranceList ? selectedinsuranceList : [];
      }

      if (this.props.hospitalListRedux) {
        let selectedhospitalList = this.props.hospitalListRedux;
        hospitalList = selectedhospitalList ? selectedhospitalList : [];
      }
      if (this.props.patientStatusListRedux) {
        let selectedpatientStatusList = this.props.patientStatusListRedux;
        patientStatusList = selectedpatientStatusList
          ? selectedpatientStatusList
          : [];
      }
      if (this.props.userInfoRedux) {
        let userInfoRedux = this.props.userInfoRedux;
        userInfo = userInfoRedux ? userInfoRedux : {};
      }
      this.setState({
        reduxLoadFlag: this.props.reduxLoadFlag,
        categoryList: categoryList,
        insuranceList: insuranceList,
        hospitalList: hospitalList,
        patientStatusList: patientStatusList,
        userInfo: userInfo,
      });
    }
  }
  componentWillUnmount() {
    Object.getPrototypeOf(this).constructor.STATE = this.state;
  }
  async fetchPage() {
    let showNotification = {};
    let apiUrl = "";
    apiUrl = apiPath.providerPageStageList;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        console.log(response);
        if (response.status === 400) {
          showNotification = {
            title: "Facility",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
        } else if (response.status === 401) {
        } else {
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          if (data.orgTab == false) {
            window.location.replace(
              basePath + providerBaseRoutes.profile.path + "?tab=orginational",
            );
          } else if (data.subscriptionTab == false) {
            window.location.replace(
              basePath + providerBaseRoutes.profile.path + "?tab=billing",
            );
          } else if (data.patientCriteria == false) {
            window.location.replace(
              basePath + providerBaseRoutes.profile.path + "?tab=criteria",
            );
          }

          console.log(data.orgTab, "xcc");
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Facility",
          message: "Bad response from server",
          type: "danger",
        };
      });
  }
  async fetchFilter() {
    let showNotification = {};
    let apiUrl = "";
    apiUrl = apiPath.getProviderFilterList;
    await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Facility",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
        } else if (response.status === 401) {
        } else {
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          this.setState({
            filterList: data,
          });
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Facility",
          message: "Bad response from server",
          type: "danger",
        };
      });
  }
  async fetchPatients(isDeclineOrAccept) {
    this.setState({
      loadingPatient: true,
    });
    let showNotification = {};
    let apiUrl = "";
    let searchKeyword = this.state.patientSearchKeyword;
    let referralType = localStorage.getItem("selectedReferral")
      ? localStorage.getItem("selectedReferral") == "all"
        ? "&showAll=true"
        : ""
      : "";
    console.log(referralType);
    if (searchKeyword && searchKeyword.length > 0) {
      apiUrl =
        apiPath.providerReferralList +
        "?page=" +
        this.state.currentPage +
        referralType +
        "&size=" +
        this.state.perPage +
        "&filterBy=" +
        (this.state.filterby && this.state.filterby != ""
          ? this.state.filterby
          : "") +
        "&insuranceId=" +
        this.state.filterbyinsuranceId +
        "&sort=" +
        (this.state.filter && this.state.filter != ""
          ? this.state.filter
          : "createdDate") +
        "," +
        (this.state.sorting && this.state.sorting != ""
          ? this.state.sorting
          : "desc") +
        "&search=" +
        searchKeyword;
    } else {
      console.log(referralType);
      apiUrl =
        apiPath.providerReferralList +
        "?page=" +
        this.state.currentPage +
        referralType +
        "&size=" +
        this.state.perPage +
        "&filterBy=" +
        (this.state.filterby && this.state.filterby != ""
          ? this.state.filterby
          : "") +
        "&insuranceId=" +
        this.state.filterbyinsuranceId +
        "&sort=" +
        (this.state.filter && this.state.filter != ""
          ? this.state.filter
          : "createdDate") +
        "," +
        (this.state.sorting && this.state.sorting != ""
          ? this.state.sorting
          : "desc") +
        "";
    }
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Facility",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
          let totalPatientCount = response.headers.get("X-Total-Count");
          this.setState({
            total: totalPatientCount,
          });
        } else if (response.status === 401) {
          userService.logout();
          //window.location.reload(true);
          window.location.replace(baseRoutes.login.path);
        } else {
          showNotification = {
            title: "Facility",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        let localPatientList = this.state.patientList;
        if (this.state.currentPage == 0) {
          localPatientList = data;
        } else {
          localPatientList = localPatientList.concat(data);
        }
        let totalPatientShowing = localPatientList.length;
        let loadMore = false;
        let loadingState = false;
        let currentPage = this.state.currentPage;
        if (this.state.total > totalPatientShowing && !isDeclineOrAccept) {
          loadMore = true;
          loadingState = true;
          currentPage = currentPage + 1;
        }
        localStorage.setItem(PATIENT_LIST, JSON.stringify(localPatientList));
        this.setState({
          patientList: localPatientList,
          totalPatientShowing: totalPatientShowing,
          loadMore: loadMore,
          currentPage: currentPage,
          loadingState: loadingState,
          loadingPatient: false,
        });
        userService.showNotification(showNotification);
      })
      .catch((error) => {
        showNotification = {
          title: "Facility",
          message: "Bad response from server",
          type: "danger",
        };
        this.setState({
          loadingPatient: false,
        });
        userService.showNotification(showNotification);
        return response;
      });
    this.props.reduxLoad(true);
  }
  handleChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateDeclineReferralFormField(name, value);
      },
    );
  };
  handleSubmit(event) {
    event.preventDefault();
    if (this.state.selectedPatientId && this.state.selectedPatientData) {
      this.updatePatient(false);
    } else {
      this.createPatient();
    }
  }
  validateDeclineReferralFormField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let declineReasonValid = this.state.declineReasonValid;

    switch (fieldName) {
      case "declineReason":
        let errMsg = "";
        if (fieldValue.trim().length > 0) {
          if (fieldValue.trim().length > 255) {
            declineReasonValid = false;
            errMsg = "Reason cannot be greater than 255 characters.";
          } else {
            declineReasonValid = true;
          }
        } else {
          declineReasonValid = false;
          errMsg = enMsg.reasonRequiredMsg;
        }
        fieldValidationErrors.declineReason = declineReasonValid ? "" : errMsg;
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        declineReasonValid: declineReasonValid,
      },
      this.validateDeclineReferralForm,
    );
  };
  validateDeclineReferralForm() {
    return this.state.declineReasonValid;
  }
  search(event) {
    let searchKeyword = event.target.value.trim();
    this.setState({
      patientSearchKeyword: searchKeyword,
      currentPage: 0,
      selectedPatientId: "",
      patientName: "",
      patientCategoryList: [],
    });
    return true;
  }
  handlePatientSorting = (event) => {
    const name = event.target.name;
    let sortByValue = event.target.value;
    if (name == "filterbyinsuranceId") {
      sortByValue =
        event.target.value || event.target.value == "0"
          ? event.target.value
          : "";
    }

    this.setState(
      {
        [name]: sortByValue,
        currentPage: 0,
      },
      () => this.fetchPatients(),
    );
  };

  loadMorePatient() {
    let localPatientList = this.state.patientList;
    this.setState(
      {
        loadMore: false,
      },
      () => this.fetchPatients(),
    );
  }

  selectPatientCategory = (catagoryId) => {
    let patientCategories = this.state.patientCategories;
    if (patientCategories.includes(catagoryId)) {
      const index = patientCategories.indexOf(catagoryId);
      if (index > -1) {
        patientCategories.splice(index, 1);
      }
    } else {
      patientCategories.push(catagoryId);
    }
    this.setState(
      {
        patientCategories: patientCategories,
      },
      () => {
        this.validateField("patientCategoties", patientCategories);
      },
    );
  };
  getPercentageCategoryVales(percentageVal, valueArr) {
    var max_of_array = Math.max.apply(Math, valueArr);
    var percent = (max_of_array * percentageVal) / 100;
    let localArr = [];
    localArr = valueArr.map((arrVal, key) => {
      if (arrVal < 0) {
        arrVal = arrVal * percent;
      }
      return arrVal;
    });
    return localArr;
  }

  refferalActionModalOpen = () => {
    let fieldValidationErrors = this.state.formErrors;
    fieldValidationErrors.declineReason = "";
    this.setState({
      referralActionModalStatus: true,
      declineReason: "",
      formErrors: fieldValidationErrors,
    });
  };
  refferalActionModalClose = () => {
    this.setState({
      referralActionModalStatus: false,
    });
  };
  acceptedReferralModalOpen = () => {
    this.setState({
      acceptedReferralModalStatus: true,
    });
  };
  acceptedReferralModalClose = () => {
    this.setState({
      acceptedReferralModalStatus: false,
    });
  };
  updateReferralStatus = (id, value, comment) => {
    this.state.patientList.map((patient, index) => {
      if (patient.id == this.state.selectedPatientData.id) {
        this.setState({
          patientList: update(this.state.patientList, {
            [index]: {
              refferalProviderEntity: {
                0: {
                  masterRefferalStatusEntity: {
                    id: {
                      $set: id,
                    },
                    refferalStatusValue: {
                      $set: value,
                    },
                  },
                },
              },
            },
          }),
          selectedPatientData: update(this.state.selectedPatientData, {
            refferalProviderEntity: {
              0: {
                masterRefferalStatusEntity: {
                  id: {
                    $set: id,
                  },
                  refferalStatusValue: {
                    $set: value,
                  },
                },
                comment: {
                  $set: comment,
                },
              },
            },
          }),
        });
      }
    });
  };
  async declineFormSubmit(e) {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    let showNotification = {};
    let apiUrl =
      apiPath.providerDeclineReferral +
      "?refferalId=" +
      this.state.selectedPatientData.refferalId +
      "&comment=" +
      this.state.declineReason;
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
          this.updateReferralStatus(5, "Decline", this.state.declineReason);
          showNotification = {
            title: "Referral",
            message: "Referral has been declined.",
            type: "success",
          };
        } else {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.status == 400 && data.title) {
          showNotification = {
            title: "Referral",
            message: data.title,
            type: "danger",
          };
        }
      })
      .catch((error) => {});
    this.setState({
      loading: false,
    });
    this.refferalActionModalClose();
    userService.showNotification(showNotification);
  }
  getPatientHospitalName(patientHospitalId) {
    this.state.hospitalList.map((el) => {
      if (el.previousHospitalId == patientHospitalId) {
        return el.hospitalName;
      }
    });
  }
  selectPatientDetail = async (
    id,
    refferalId,
    renderKey,
    isReload,
    modalKey,
  ) => {
    this.setState({
      loading: true,
    });
    if (isReload != "false") {
      this.setState({
        loading: true,
        selectedPatientData: "",
      });
    }
    let showNotification = {};
    let apiUrl = apiPath.getReferralDetail + "?refferalId=" + refferalId;
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.status == 400 && data.title) {
          showNotification = {
            title: "Referral",
            message: data.title,
            type: "danger",
          };
        }
        if (data.refferalId) {
          let patient = data;
          if (isReload == "false" && patient.refferalStatus != 1) {
            this.providerCommentModalOpen(modalKey);
          }
          let categoryValue = "";
          let hospitalValue = "";
          let insuranceName = "";
          let searchCriteria = [];
          let categoryId = "";
          let estimateDischargeDate = "";
          let actualDischargeDate = null;
          let patientList = [...this.state.patientList];
          let newPatientList = [];
          let selectedcomment = "";
          if (
            data.refferalProviderEntity[0].refferalProviderComment.length >=
              2 &&
            data.refferalProviderEntity[0].refferalProviderComment[1].comment
          ) {
            selectedcomment =
              data.refferalProviderEntity[0].refferalProviderComment[1].comment;
          }
          if (patientList && patientList.length) {
            newPatientList = patientList.map((pList) => {
              if (pList.id == id) {
                pList = patient;
              }
              return pList;
            });
          }
          if (
            patient.refferalPatientEntity[0] &&
            patient.refferalPatientEntity[0].searchHistory
          ) {
            const url = new URLSearchParams(
              patient.refferalPatientEntity[0].searchHistory.search,
            );
            let subCategoryId = url.get("subCategoryId");
            subCategoryId = subCategoryId.split(",");
            if (subCategoryId && subCategoryId[1]) {
              categoryId = subCategoryId[1]
                .split("-")
                .map((item) => Number(item));
            }
          }
          if (patient.refferalPatientEntity[0]) {
            this.state.insuranceList.map((el) => {
              if (
                el.insuranceId ==
                patient.refferalPatientEntity[0].patientEntity.insuranceId
              ) {
                insuranceName = el.insuranceName;
              }
            });
          }
          this.state.categoryList.map((el) => {
            if (el.id == patient.categoryId) {
              categoryValue = el.categoryValue;
            }
            if (categoryId && categoryId.includes(el.id)) {
              searchCriteria.push(el.categoryValue);
            }
          });
          if (patient.refferalPatientEntity[0]) {
            this.state.hospitalList.map((el) => {
              if (
                el.previousHospitalId ==
                patient.refferalPatientEntity[0].patientEntity
                  .previousHospitalId
              ) {
                hospitalValue = el.hospitalName;
              }
            });
          }
          estimateDischargeDate = this.dateUtility.format(
            new Date(
              patient.refferalPatientEntity[0].patientEntity.formattedEstimatedDischargeDate,
            ),
            "MM/dd/yyyy",
          );
          actualDischargeDate =
            patient.refferalPatientEntity[0].patientEntity
              .actualDischargeDate &&
            this.dateUtility.format(
              new Date(
                patient.refferalPatientEntity[0].patientEntity.actualDischargeDate,
              ),
              "MM/dd/yyyy",
            );

          const statusId = patient?.refferalProviderEntity?.[0]?.masterRefferalStatusEntity?.id;
          const isPreliminary = patient?.refferalType == 1;
          const isRapid = patient?.refferalType == 0;
          const shouldAutoAck = statusId === 4 && (isPreliminary || isRapid);
          // Optimistic UI: flip the badge to Acknowledged immediately so the
          // right panel doesn't flash "Pending" while the background API call
          // is in flight. The server response will overwrite with the same
          // status, so no second render.
          if (shouldAutoAck) {
            patient.refferalProviderEntity[0].masterRefferalStatusEntity = {
              ...patient.refferalProviderEntity[0].masterRefferalStatusEntity,
              id: 6,
              refferalStatusValue: "Acknowledged",
            };
          }

          this.setState({
            patientList: newPatientList,
            selectedPatientData: patient,
            searchCriteria: searchCriteria,
            selectedPatientCategoryValue: categoryValue,
            selectedPatientHospitalValue: hospitalValue,
            selectedPatientInsuranceValue: insuranceName,
            patientListSeletedIndex: renderKey,
            estimateDischargeDate: estimateDischargeDate,
            actualDischargeDate: actualDischargeDate,
            selectRererralId: refferalId,
            selectRererralItemId: id,
            refferalTransportEntity: data.refferalTransportEntity,
            refferalDmeEntity: data.refferalDmeEntity,
            selectedcomment: selectedcomment,
            // Show mobile referral popup when on mobile/tablet device (991px and below)
            mobileReferralPopupOpen: window.innerWidth <= 991,
            // Reset content viewer states when selecting new patient
            mobileContentViewerOpen: false,
            contentViewerOpen: false,
            viewerContent: "",
            viewerContentType: "",
            viewerFileName: "",
          }, () => {
            if (statusId === 4 && isPreliminary) {
              // Preliminary: existing /referral-accepted path acknowledges (status 6)
              // without finalizing for prelim, so it doubles as auto-view.
              this.acceptReferral(null, { silent: true });
            } else if (statusId === 4 && isRapid) {
              // Rapid: dedicated /referral-viewed endpoint flips per-provider
              // status Pending -> Acknowledged. Accept stays an explicit action.
              this.markReferralViewed(null, { silent: true });
            }
          });
        }
        console.log("This is all data: " + data);
        userService.showNotification(showNotification);
        return data;
      })
      .catch((error) => {});
    this.setState({
      loading: false,
    });
    return;
  };
  isReferralAccessAllowed = () => {
    const sentTime = this.state.selectedPatientData?.refferalSendTime;
    if (!sentTime) return true;
    const ageDays = (Date.now() - new Date(sentTime).getTime()) / (1000 * 60 * 60 * 24);
    return ageDays <= 30;
  };

  acceptReferral = async (event, { silent = false } = {}) => {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    if (!silent) {
      this.setState({
        loading: true,
      });
    }
    let showNotification = {};
    let apiUrl =
      apiPath.providerAcceptReferral +
      "?refferalId=" +
      this.state.selectedPatientData.refferalId;
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
          this.updateReferralStatus(6, "Accepted", "");
          showNotification = {
            title: "Referral",
            message: "Referral has been accepted.",
            type: "success",
          };
        } else {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.status == 400 && data.title) {
          showNotification = {
            title: "Referral",
            message: data.title,
            type: "danger",
          };
        } else if (data.id) {
          let localPatients = [];
          let localPatientArr = this.state.patientList;
          if (localPatientArr && localPatientArr.length) {
            localPatients = localPatientArr.map((pList) => {
              if (pList.id == data.id) {
                if (
                  data.refferalProviderEntityNew &&
                  data.refferalProviderEntityNew.length
                ) {
                  data.refferalProviderEntity = data.refferalProviderEntityNew;
                }
                pList = data;
              }
              return pList;
              console.log(data);
            });
          }
          this.setState({
            selectedPatientData: data,
            patientList: localPatients,
          });
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Referral",
          message: "Bad response from server",
          type: "danger",
        };
      });
    if (!silent) {
      this.setState({
        loading: false,
      });
      this.acceptedReferralModalClose();
      userService.showNotification(showNotification);
    }
  };

  markReferralViewed = async (event, { silent = false } = {}) => {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    if (!silent) {
      this.setState({ loading: true });
    }
    let showNotification = {};
    const apiUrl =
      apiPath.providerMarkReferralViewed +
      "?refferalId=" +
      this.state.selectedPatientData.refferalId;
    await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.ok) {
          this.updateReferralStatus(6, "Acknowledged", "");
        } else if (!silent) {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.id) {
          this.setState({ selectedPatientData: data });
        }
      })
      .catch(() => {
        if (!silent) {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        }
      });
    if (!silent) {
      this.setState({ loading: false });
      if (showNotification.title) {
        userService.showNotification(showNotification);
      }
    }
  };

  canAcceptReferral = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    let showNotification = {};
    let apiUrl =
      apiPath.providerCanAcceptReferral +
      "?refferalId=" +
      this.state.selectedPatientData.refferalId +
      "&comment=" +
      encodeURIComponent(this.state.canAcceptComment);
    await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.ok) {
          this.updateReferralStatus(
            9,
            "Can Accept",
            this.state.canAcceptComment,
          );
          showNotification = {
            title: "Referral",
            message: "Marked as Can Accept.",
            type: "success",
          };
          return null;
        } else {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
          return response.json();
        }
      })
      .then((data) => {
        if (data && data.status == 400 && data.title) {
          showNotification = {
            title: "Referral",
            message: data.title,
            type: "danger",
          };
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Referral",
          message: "Bad response from server",
          type: "danger",
        };
      });
    this.setState({ loading: false, canAcceptComment: "" });
    userService.showNotification(showNotification);
  };

  providerCommentModalOpen = (key) => {
    this.setState({
      selectedPatientKey: key,
      providerCommentModalStatus: true,
    });
  };
  providerCommentModalClose = () => {
    this.setState({
      providerCommentModalStatus: false,
    });
  };
  confirmModalOpen = (message) => {
    this.setState({
      confirmModalMessage: message,
      confirmModalStatus: true,
    });
  };
  confirmModalClose = () => {
    this.setState({
      confirmModalStatus: false,
    });
  };
  confirmCommentModalClose = () => {
    this.setState({
      confirmBoxStatus: false,
    });
  };
  confirmCommentModalOpen = () => {
    this.setState({
      confirmBoxStatus: true,
    });
  };
  removeRequestFromDash = async () => {
    this.setState({
      loading: true,
    });
    let showNotification = {};
    let apiUrl =
      apiPath.removeReferralFromDashboard +
      "?refferalId=" +
      this.state.selectedPatientData.refferalId;
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
          this.setState((prevState) => ({
            patientList: update(prevState.patientList, {
              $splice: [[this.state.patientListSeletedIndex, 1]],
            }),
            selectedPatientData: "",
            total: prevState.total - 1,
          }));
          showNotification = {
            title: "Referral",
            message: "Referral has been removed.",
            type: "success",
          };
        } else {
          showNotification = {
            title: "Referral",
            message: "Bad response from server",
            type: "danger",
          };
        }
      })
      .then((data) => {})
      .catch((error) => {
        showNotification = {
          title: "Referral",
          message: "Bad response from server",
          type: "danger",
        };
      });
    this.setState({
      loading: false,
    });
    this.confirmModalClose();
    userService.showNotification(showNotification);
    window.location.reload();
  };
  searchReturn(event) {
    if (event.target.keyCode === 13 || event.key === "Enter") {
      event.preventDefault();
      this.fetchPatients();
    }
  }
  handleChangeInputForComment = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      },
    );
  };
  validateField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let commentToDPValid = this.state.commentToDPValid;
    switch (fieldName) {
      case "commentToDP":
        let commentErr = "";
        if (fieldValue.trim().length == 0) {
          commentToDPValid = false;
          commentErr = "Comment is required";
        } else if (fieldValue.trim().length > MAX_INPUT_LENGTH_LONG) {
          commentToDPValid = false;
          commentErr = "Comment length cannot exceed 255 characters";
        } else {
          commentToDPValid = true;
          commentErr = "";
        }
        fieldValidationErrors.commentToDP = commentErr;
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        commentToDPValid: commentToDPValid,
      },
      this.validateForm,
    );
  };
  validateForm() {
    return this.state.commentToDPValid;
  }

  sendComment = async (event) => {
    event.preventDefault();
    let data = {
      comment: this.state.commentToDP,
      providerId: this.state.selectedPatientData.refferalProviderEntity[0]
        .providerId,
      refferalId: this.state.selectedPatientData.refferalId,
    };
    this.setState({ loading: true });
    let showNotification = {};
    let modalCloseStatus = 1;
    const response = await fetch(apiPath.postPrelimComment, {
      method: "POST",
      headers: generalAuthTokenHeader(),
      body: JSON.stringify(data),
      data: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Comment",
            message: enMsg.badResponseFromServer,
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: "Comment",
            message: enMsg.badResponseFromServer,
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.id) {
          this.setState({
            isPrelimCommentDone: true,
            prelimCommentByProvider: data.comment,
            commentPostReferralId: this.state.selectedPatientData.refferalId,
            commentToDP: "",
          });
          showNotification = {
            title: "Comment",
            message: "Message has been sent to the dishcharge planner",
            type: "success",
          };
        } else if (data.status == 400 && data.title) {
          showNotification = {
            title: "Comment",
            message: data.title,
            type: "danger",
          };
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Comment",
          message: enMsg.clientSideError,
          type: "danger",
        };
      });
    userService.showNotification(showNotification);
    this.setState({ loading: false });
    this.setState({
      confirmBoxStatus: false,
    });
  };
  handleClose() {}
  commentBoxModalSubmit = (event) => {
    event.preventDefault();
    this.setState({
      confirmBoxStatus: true,
    });
  };

  /**
   * Open content viewer with specified content
   */
  openContentViewer = (content, contentType, fileName = "") => {
    // On mobile, open the mobile content viewer popup (second popup)
    if (window.innerWidth <= 767) {
      this.setState({
        mobileContentViewerOpen: true,
        viewerContent: content,
        viewerContentType: contentType,
        viewerFileName: fileName,
      });
    } else {
      // On desktop, open the content viewer panel
      this.setState({
        contentViewerOpen: true,
        viewerContent: content,
        viewerContentType: contentType,
        viewerFileName: fileName,
      });
    }
  };

  /**
   * Close content viewer
   */
  closeContentViewer = () => {
    // On mobile, close the mobile content viewer popup
    if (window.innerWidth <= 767) {
      this.setState({
        mobileContentViewerOpen: false,
        viewerContent: "",
        viewerContentType: "",
        viewerFileName: "",
      });
    } else {
      // On desktop, close the content viewer panel
      this.setState({
        contentViewerOpen: false,
        viewerContent: "",
        viewerContentType: "",
        viewerFileName: "",
      });
    }
  };

  /**
   * Close mobile referral popup (first popup)
   */
  closeMobileReferralPopup = () => {
    this.setState({
      mobileReferralPopupOpen: false,
      mobileContentViewerOpen: false, // Also close nested popup if open
    });
  };

  /**
   * Close mobile content viewer popup (second/nested popup)
   */
  closeMobileContentViewer = () => {
    this.setState({
      mobileContentViewerOpen: false,
    });
  };

  /**
   * Toggle mobile filters dropdown
   */
  toggleMobileFilters = () => {
    this.setState((prevState) => ({
      mobileFiltersOpen: !prevState.mobileFiltersOpen,
    }));
  };

  /**
   * Handle view AI summary
   */
  handleViewAISummary = async (patientId = null) => {
    const { selectedPatientData } = this.state;

    // If patientId not provided, use first patient from selected referral
    if (!patientId) {
      if (
        !selectedPatientData.refferalPatientEntity ||
        !selectedPatientData.refferalPatientEntity[0]
      ) {
        userService.showNotification({
          title: "Error",
          message: "Patient data not available",
          type: "danger",
        });
        return;
      }
      patientId = selectedPatientData.refferalPatientEntity[0].patientId;
    }
    this.setState({ loadingViewer: true });

    try {
      const apiUrl = `${apiPath.GetReferralSummary}/${patientId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }

      if (response.status === 404) {
        userService.showNotification({
          title: "Not Found",
          message: "No referral summary available for this patient",
          type: "info",
        });
        this.setState({ loadingViewer: false });
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch referral summary");
      }

      const data = await response.json();
      this.openContentViewer(
        data.summaryHtml || "",
        "html",
        "AI Referral Summary",
      );
      this.setState({ loadingViewer: false });
    } catch (error) {
      // console.error("Error fetching AI summary:", error);
      userService.showNotification({
        title: "Error",
        message: "Failed to load AI summary",
        type: "danger",
      });
      this.setState({ loadingViewer: false });
    }
  };

  /**
   * Handle download AI summary PDF
   */
  handleDownloadAISummary = async (patientId = null) => {
    const { selectedPatientData } = this.state;

    // If patientId not provided, use first patient from selected referral
    if (!patientId) {
      if (
        !selectedPatientData.refferalPatientEntity ||
        !selectedPatientData.refferalPatientEntity[0]
      ) {
        return;
      }
      patientId = selectedPatientData.refferalPatientEntity[0].patientId;
    }

    try {
      const apiUrl = `${apiPath.DownloadReferralSummaryPdf}/${patientId}/download-pdf`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `referral_summary_patient_${patientId}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      userService.showNotification({
        title: "Success",
        message: "PDF downloaded successfully",
        type: "success",
      });
    } catch (error) {
      console.error("Error downloading PDF:", error);
      userService.showNotification({
        title: "Error",
        message: "Failed to download PDF",
        type: "danger",
      });
    }
  };

  /**
   * Handle view document
   */
  handleViewDocument = async (documentUrl, fileName) => {
    this.setState({ loadingViewer: true });

    try {
      const patientId = this.state.selectedPatientData.refferalPatientEntity[0]
        .patientId;
      const refferalId = this.state.selectedPatientData.refferalId;

      // Extract key from URL
      const urlArr = documentUrl.split("/");
      const urlArrEndPoint =
        urlArr[urlArr.length - 2] + "/" + urlArr[urlArr.length - 1];

      const apiUrl = `${apiPath.downloadCommentFile}?key=${urlArrEndPoint}&patientId=${patientId}&refferalId=${refferalId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch document");
      }

      const blob = await response.blob();
      const fileExtension = fileName
        .split(".")
        .pop()
        .toLowerCase();

      // Determine content type based on file extension
      let contentType = "";
      let content = "";

      if (
        [
          "jpg",
          "jpeg",
          "jfif",
          "jpe",
          "png",
          "gif",
          "bmp",
          "webp",
          "svg",
        ].includes(fileExtension)
      ) {
        contentType = "image";
        content = URL.createObjectURL(blob);
      } else if (fileExtension === "pdf") {
        contentType = "pdf";
        content = URL.createObjectURL(blob);
      } else if (["doc", "docx"].includes(fileExtension)) {
        contentType = "docx";
        // Convert blob to base64 for DOCX conversion
        const reader = new FileReader();
        reader.onloadend = () => {
          this.openContentViewer(reader.result, contentType, fileName);
          this.setState({ loadingViewer: false });
        };
        reader.readAsDataURL(blob);
        return;
      } else {
        throw new Error("Unsupported file type");
      }

      this.openContentViewer(content, contentType, fileName);
      this.setState({ loadingViewer: false });
    } catch (error) {
      console.error("Error viewing document:", error);
      userService.showNotification({
        title: "Error",
        message: error.message || "Failed to view document",
        type: "danger",
      });
      this.setState({ loadingViewer: false });
    }
  };

  /**
   * Handle download document
   */
  handleDownloadDocument = async (documentUrl, fileName) => {
    try {
      const patientId = this.state.selectedPatientData.refferalPatientEntity[0]
        .patientId;
      const refferalId = this.state.selectedPatientData.refferalId;

      const urlArr = documentUrl.split("/");
      const urlArrEndPoint =
        urlArr[urlArr.length - 2] + "/" + urlArr[urlArr.length - 1];

      const apiUrl = `${apiPath.downloadCommentFile}?key=${urlArrEndPoint}&patientId=${patientId}&refferalId=${refferalId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        throw new Error("Failed to download document");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      userService.showNotification({
        title: "Success",
        message: "Document downloaded successfully",
        type: "success",
      });
    } catch (error) {
      console.error("Error downloading document:", error);
      userService.showNotification({
        title: "Error",
        message: "Failed to download document",
        type: "danger",
      });
    }
  };

  // Export Menu Handlers
  handleExportClick = (event) => {
    this.setState({ exportMenuAnchor: event.currentTarget });
  };

  handleExportClose = () => {
    this.setState({ exportMenuAnchor: null });
  };

  downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  getReferralPatientExportData = (refferalPatientItem, selectedPatientData) => {
    const patient = refferalPatientItem.patientEntity;

    // Find insurance name from insuranceList
    let insuranceName = "";
    if (this.state.insuranceList) {
      this.state.insuranceList.forEach((ins) => {
        if (ins.insuranceId === patient.insuranceId) {
          insuranceName = ins.insuranceName;
        }
      });
    }

    // Find facility name
    const facilityName =
      selectedPatientData.facilityName ||
      selectedPatientData.dischargeplannerEntity?.facility?.facilityName ||
      "";

    return {
      patientId: patient.patientId || "",
      firstName: patient.firstName || "",
      middleName: patient.middleName || "",
      lastName: patient.lastName || "",
      gender: patient.gender || "",
      comment: patient.comment || "",
      dateOfBirth: patient.formattedPatientDob || patient.patientDob || "",
      estimatedDischargeDate:
        patient.formattedEstimatedDischargeDate ||
        patient.eastimatedDischargeDate ||
        "",
      actualDischargeDate:
        patient.formattedActualDischargeDate ||
        patient.actualDischargeDate ||
        "",
      insuranceId: patient.insuranceId || "",
      insuranceName: insuranceName,
      patientStatusId: patient.patientStatusId || "",
      facilityId: patient.facilityId || "",
      facilityName: facilityName,
      referralId: selectedPatientData.refferalId || "",
      referralSendTime: selectedPatientData.refferalSendTime || "",
      referralType: selectedPatientData.refferalType || "",
    };
  };

  handleExportCSV = () => {
    const { selectedPatientData } = this.state;
    if (!selectedPatientData || !selectedPatientData.refferalPatientEntity)
      return;

    const headers = [
      "PatientID",
      "FirstName",
      "MiddleName",
      "LastName",
      "DOB",
      "Gender",
      "InsuranceID",
      "InsuranceName",
      "EstDischargeDate",
      "ActualDischargeDate",
      "FacilityName",
      "ReferralID",
      "ReferralSendDate",
      "Comments",
    ];

    const escapeCSV = (value) => {
      const str = String(value || "");
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    selectedPatientData.refferalPatientEntity.forEach((refPatient, index) => {
      const data = this.getReferralPatientExportData(
        refPatient,
        selectedPatientData,
      );

      const values = [
        data.patientId,
        data.firstName,
        data.middleName,
        data.lastName,
        data.dateOfBirth,
        data.gender,
        data.insuranceId,
        data.insuranceName,
        data.estimatedDischargeDate,
        data.actualDischargeDate,
        data.facilityName,
        data.referralId,
        data.referralSendTime,
        data.comment,
      ].map(escapeCSV);

      const csvContent = headers.join(",") + "\n" + values.join(",");
      const filename = `patient_${data.patientId}_${data.lastName}_${data.firstName}.csv`;

      // Delay each download slightly to avoid browser blocking
      setTimeout(() => {
        this.downloadFile(csvContent, filename, "text/csv;charset=utf-8;");
      }, index * 300);
    });

    this.handleExportClose();
  };

  handleExportHL7 = () => {
    const { selectedPatientData } = this.state;
    if (!selectedPatientData || !selectedPatientData.refferalPatientEntity)
      return;

    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      return moment(dateStr).format("YYYYMMDD");
    };

    const escapeHL7 = (str) => {
      if (!str) return "";
      return String(str)
        .replace(/\|/g, "\\F\\")
        .replace(/\^/g, "\\S\\")
        .replace(/~/g, "\\R\\")
        .replace(/\\/g, "\\E\\")
        .replace(/&/g, "\\T\\")
        .replace(/\n/g, "~");
    };

    selectedPatientData.refferalPatientEntity.forEach((refPatient, index) => {
      const data = this.getReferralPatientExportData(
        refPatient,
        selectedPatientData,
      );
      const now = moment().format("YYYYMMDDHHmmss");
      const genderCode = data.gender ? data.gender.charAt(0).toUpperCase() : "";

      const segments = [
        `MSH|^~\\&|MAXMRJ|${escapeHL7(
          data.facilityName,
        )}|||${now}||ADT^A01|MSG${data.referralId}_${data.patientId}|P|2.5`,
        `PID|1||${data.patientId}||${escapeHL7(data.lastName)}^${escapeHL7(
          data.firstName,
        )}^${escapeHL7(data.middleName)}||${formatDate(
          data.dateOfBirth,
        )}|${genderCode}`,
        `PV1|1|O||||||||||||||||||||||${formatDate(
          data.estimatedDischargeDate,
        )}`,
        data.insuranceName ? `IN1|1||${escapeHL7(data.insuranceName)}` : "",
        data.comment ? `NTE|1||${escapeHL7(data.comment)}` : "",
      ].filter(Boolean);

      const hl7Content = segments.join("\r");
      const filename = `patient_${data.patientId}_${data.lastName}_${data.firstName}.hl7`;

      setTimeout(() => {
        this.downloadFile(
          hl7Content,
          filename,
          "application/hl7-v2;charset=utf-8;",
        );
      }, index * 300);
    });

    this.handleExportClose();
  };

  handleExportJSON = () => {
    const { selectedPatientData } = this.state;
    if (!selectedPatientData || !selectedPatientData.refferalPatientEntity)
      return;

    selectedPatientData.refferalPatientEntity.forEach((refPatient, index) => {
      const data = this.getReferralPatientExportData(
        refPatient,
        selectedPatientData,
      );

      const jsonExport = {
        exportInfo: {
          format: "MaxMRJ Patient Export",
          version: "1.0",
          exportedAt: new Date().toISOString(),
          source: "MaxMRJ Healthcare System",
        },
        patient: {
          id: data.patientId,
          demographics: {
            firstName: data.firstName,
            middleName: data.middleName,
            lastName: data.lastName,
            dateOfBirth: data.dateOfBirth,
            gender: data.gender,
          },
          insurance: {
            id: data.insuranceId,
            name: data.insuranceName,
          },
          clinical: {
            estimatedDischargeDate: data.estimatedDischargeDate,
            actualDischargeDate: data.actualDischargeDate,
            comments: data.comment,
          },
          facility: {
            id: data.facilityId,
            name: data.facilityName,
          },
          referral: {
            referralId: data.referralId,
            referralSendTime: data.referralSendTime,
            referralType: data.referralType,
          },
        },
      };

      const jsonContent = JSON.stringify(jsonExport, null, 2);
      const filename = `patient_${data.patientId}_${data.lastName}_${data.firstName}.json`;

      setTimeout(() => {
        this.downloadFile(
          jsonContent,
          filename,
          "application/json;charset=utf-8;",
        );
      }, index * 300);
    });

    this.handleExportClose();
  };

  handleExportXML = () => {
    const { selectedPatientData } = this.state;
    if (!selectedPatientData || !selectedPatientData.refferalPatientEntity)
      return;

    const escapeXML = (str) => {
      if (!str) return "";
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
    };

    selectedPatientData.refferalPatientEntity.forEach((refPatient, index) => {
      const data = this.getReferralPatientExportData(
        refPatient,
        selectedPatientData,
      );

      const xmlContent = `<?xml version="1.0" encoding="UTF-8"?>
<ClinicalDocument xmlns="urn:hl7-org:v3">
  <realmCode code="US"/>
  <typeId root="2.16.840.1.113883.1.3" extension="POCD_HD000040"/>
  <title>Patient Clinical Summary</title>
  <effectiveTime value="${moment().format("YYYYMMDDHHmmss")}"/>
  <recordTarget>
    <patientRole>
      <id extension="${escapeXML(data.patientId)}" root="MaxMRJ"/>
      <patient>
        <name>
          <given>${escapeXML(data.firstName)}</given>
          <given>${escapeXML(data.middleName)}</given>
          <family>${escapeXML(data.lastName)}</family>
        </name>
        <administrativeGenderCode code="${escapeXML(
          data.gender ? data.gender.charAt(0).toUpperCase() : "",
        )}" displayName="${escapeXML(data.gender)}"/>
        <birthTime value="${
          data.dateOfBirth ? moment(data.dateOfBirth).format("YYYYMMDD") : ""
        }"/>
      </patient>
    </patientRole>
  </recordTarget>
  <component>
    <structuredBody>
      <component>
        <section>
          <title>Insurance Information</title>
          <text>
            <table>
              <tbody>
                <tr><td>Insurance ID</td><td>${escapeXML(
                  data.insuranceId,
                )}</td></tr>
                <tr><td>Insurance Name</td><td>${escapeXML(
                  data.insuranceName,
                )}</td></tr>
              </tbody>
            </table>
          </text>
        </section>
      </component>
      <component>
        <section>
          <title>Discharge Information</title>
          <text>
            <table>
              <tbody>
                <tr><td>Facility</td><td>${escapeXML(
                  data.facilityName,
                )}</td></tr>
                <tr><td>Estimated Discharge Date</td><td>${escapeXML(
                  data.estimatedDischargeDate,
                )}</td></tr>
                <tr><td>Actual Discharge Date</td><td>${escapeXML(
                  data.actualDischargeDate,
                )}</td></tr>
              </tbody>
            </table>
          </text>
        </section>
      </component>
      <component>
        <section>
          <title>Referral Information</title>
          <text>
            <table>
              <tbody>
                <tr><td>Referral ID</td><td>${escapeXML(
                  data.referralId,
                )}</td></tr>
                <tr><td>Referral Send Time</td><td>${escapeXML(
                  data.referralSendTime,
                )}</td></tr>
              </tbody>
            </table>
          </text>
        </section>
      </component>
      <component>
        <section>
          <title>Comments</title>
          <text>${escapeXML(data.comment)}</text>
        </section>
      </component>
    </structuredBody>
  </component>
</ClinicalDocument>`;

      const filename = `patient_${data.patientId}_${data.lastName}_${data.firstName}.xml`;

      setTimeout(() => {
        this.downloadFile(
          xmlContent,
          filename,
          "application/xml;charset=utf-8;",
        );
      }, index * 300);
    });

    this.handleExportClose();
  };

  render() {
    const {
      currentPage,
      total,
      sorting,
      filter,
      patientCategoryList,
      loading,
      patientName,
      selectedPatientId,
      patientList,
      hospital,
      insurance,
      gender,
      insuranceList,
      categoryList,
      hospitalList,
      patientCategories,
      selectionCount,
      selectedPatientData,
      totalPatientShowing,
      filterby,
      filterbyinsuranceId,
    } = this.state;
    const { classes } = this.props;
    // const menu = this.menuItems;
    return (
      <div id="facility-index">
        <ConfirmModal
          title="Alert"
          message={this.state.confirmModalMessage}
          confirmModalStatus={this.state.confirmModalStatus}
          confirmModalClose={this.confirmModalClose}
          submit={this.removeRequestFromDash}
          loading={this.state.loading}
        />
        <ChangePassword
          id="change-pssword-dialog"
          keepMounted
          open={this.state.openModal}
          handleChangePasswordDialog={this.handleClose}
          onClose={this.handleClose}
          value={""}
          allowCloseModal={false}
        />
        <BAAComponent
          open={this.state.bbaCondition}
          handleBAAAgree={this.handleBAAAgree}
        />
        <TermsComponent
          open={this.state.termNcondition}
          handleTNCAgree={this.handleTNCAgree}
        />
        {selectedPatientData && (
          <ProviderCommentModal
            status={this.state.providerCommentModalStatus}
            close={this.providerCommentModalClose}
            selectedPatientData={selectedPatientData}
            selectedPatientInsuranceValue={
              this.state.selectedPatientInsuranceValue
            }
            insuranceList={this.state.insuranceList}
            searchCriteria={this.state.searchCriteria}
            categoryList={this.state.categoryList}
            estimateDischargeDate={this.state.estimateDischargeDate}
            actualDischargeDate={this.state.actualDischargeDate}
            commentsThread={this.state.commentsThread}
            selectedPatientKey={this.state.selectedPatientKey}
          />
        )}

        <Dialog
          open={this.state.referralActionModalStatus}
          maxWidth={"sm"}
          onClose={this.refferalActionModalClose}
          TransitionComponent={Transition}
          aria-labelledby="decline-referral-title"
          className="add-modal front-modal ref-decline-modal"
        >
          <DialogTitle
            className="add-modal-title decline-text"
            id="decline-referral-title"
          >
            This will decline the Referral: {selectedPatientData.refferalId}{" "}
            {(selectedPatientData.facilityName ||
              selectedPatientData.dischargeplannerEntity?.facility
                ?.facilityName) &&
              `from ` +
                (selectedPatientData.facilityName ||
                  selectedPatientData.dischargeplannerEntity.facility
                    .facilityName)}
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.refferalActionModalClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <form onSubmit={this.declineFormSubmit}>
            <DialogContent>
              <Box display="flex" justifyContent="flex-start" mb={2}>
                <Box pr={1} width={1}>
                  <TextField
                    name="declineReason"
                    value={this.state.declineReason}
                    onChange={this.handleChangeInput}
                    data-validators="isRequired"
                    label="Decline Reason"
                    multiline={true}
                    rows={4}
                    InputLabelProps={{ className: "required-label" }}
                  />
                  <FormErrors
                    show={!this.state.declineReasonValid}
                    formErrors={this.state.formErrors}
                    fieldName="declineReason"
                  />
                </Box>
              </Box>
            </DialogContent>
            <DialogActions className="modal-actions" justify="center">
              <Button
                type="submit"
                className="btn5 dec"
                disabled={!this.validateDeclineReferralForm()}
              >
                {this.state.loading && (
                  <CircularProgress size={24} className="buttonProgress" />
                )}
                Decline Referral
              </Button>
              <Button onClick={this.refferalActionModalClose} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <Dialog
          open={this.state.acceptedReferralModalStatus}
          maxWidth={"sm"}
          onClose={this.acceptedReferralModalClose}
          TransitionComponent={Transition}
          aria-labelledby="decline-referral-title"
          className="add-modal ref-accept-modal"
        >
          <DialogTitle className="add-modal-title" id="decline-referral-title">
            {selectedPatientData.refferalType == 1 ? (
              <div>
                Acknowledging Referral ID: {selectedPatientData.refferalId}{" "}
                {(selectedPatientData.facilityName ||
                  selectedPatientData.dischargeplannerEntity?.facility
                    ?.facilityName) &&
                  `for ` +
                    (selectedPatientData.facilityName ||
                      selectedPatientData.dischargeplannerEntity.facility
                        .facilityName)}
              </div>
            ) : (
              <div>
                Accepting Referral ID: {selectedPatientData.refferalId}{" "}
                {(selectedPatientData.facilityName ||
                  selectedPatientData.dischargeplannerEntity?.facility
                    ?.facilityName) &&
                  `for ` +
                    (selectedPatientData.facilityName ||
                      selectedPatientData.dischargeplannerEntity.facility
                        .facilityName)}
              </div>
            )}
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.acceptedReferralModalClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <form onSubmit={this.acceptReferral} noValidate>
            <DialogContent>
              <Box display="flex" justifyContent="flex-start">
                <Box pr={1} width={1}>
                  <p>
                    You are{" "}
                    {selectedPatientData.refferalType == 1
                      ? "acknowledging"
                      : "accepting"}{" "}
                    the referral under the{" "}
                    {this.state.selectedPatientCategoryValue} category for{" "}
                    {selectedPatientData &&
                      selectedPatientData.refferalPatientEntity.length}{" "}
                    patient(s).
                  </p>
                  <br></br>
                  <p>
                    Do you want to{" "}
                    {selectedPatientData.refferalType == 1
                      ? "acknowledge"
                      : "accept"}{" "}
                    this Referral Request?
                  </p>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions className="modal-actions" justify="center">
              <Button type="submit" className="btn3">
                {this.state.loading && (
                  <CircularProgress size={24} className="buttonProgress" />
                )}
                {selectedPatientData.refferalType == 1
                  ? "Acknowledge Receipt"
                  : "Accept Referral"}
              </Button>
              <Button onClick={this.acceptedReferralModalClose} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <Dialog
          open={this.state.confirmBoxStatus}
          maxWidth={"xs"}
          onClose={this.confirmCommentModalOpen}
          TransitionComponent={Transition}
          aria-labelledby="form-dialog-title"
          className="add-modal front-modal "
        >
          <DialogTitle className="add-modal-title" id="form-dialog-title">
            Comment
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.handleCloseCommentStatus}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              width={1}
              display="flex"
              justifyContent="flex-start"
              mb={1}
              mt={1}
            >
              <Box pr={2}>Do you want submit ?</Box>
            </Box>
          </DialogContent>
          <DialogActions className="modal-actions" justify="center">
            <Button type="button" className="btn1" onClick={this.sendComment}>
              Confirm
            </Button>
            <Button
              onClick={this.confirmCommentModalClose}
              className="cancel-link"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        {this.state.loadingPatient || !this.state.reduxLoadFlag ? (
          <div className="LinearProgress-ref">
            <LinearProgress />
          </div>
        ) : (
          <div className="LinearProgress-ref"></div>
        )}
        {!this.state.openModal &&
        !this.state.bbaCondition &&
        !this.state.termNcondition ? (
          <Box className="patient-dashboard-box" p={3}>
            {/* Patient Tabs */}
            <PatientTabs activeTab="referrals" />

            <div className="left-content-header content-header">
              {/* ===== MOBILE FILTER HEADER - Only visible on mobile ===== */}
              <div className="mobile-filter-header">
                <div className="mobile-filter-row-1">
                  <span className="titlename">All Referrals</span>
                  <span className="show-text">
                    {totalPatientShowing}/{total} Referral
                    {total !== 1 ? "s" : ""}
                  </span>
                </div>
                <div className="mobile-filter-row-2">
                  <div className="mobile-search-wrapper">
                    <Paper
                      component="form"
                      className="search-box-cover filter-box"
                    >
                      <InputBase
                        className="search-box"
                        placeholder="Search Referral"
                        onChange={this.search}
                        onKeyPress={this.searchReturn}
                      />
                      <IconButton
                        aria-label="search"
                        style={{ padding: "5px" }}
                        onClick={this.fetchPatients}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Paper>
                  </div>
                  <IconButton
                    aria-label="filters"
                    onClick={this.toggleMobileFilters}
                    className="filter-icon-btn"
                  >
                    <FilterListIcon />
                  </IconButton>
                </div>
              </div>

              {/* Mobile Filter Sidenav Overlay */}
              {this.state.mobileFiltersOpen && (
                <div
                  className="mobile-filter-overlay"
                  onClick={this.toggleMobileFilters}
                />
              )}

              {/* Mobile Filter Sidenav Drawer */}
              <div
                className={`mobile-filter-sidenav ${
                  this.state.mobileFiltersOpen ? "sidenav-open" : ""
                }`}
              >
                <div className="sidenav-header">
                  <span className="sidenav-title">Filters</span>
                  <IconButton
                    aria-label="close filters"
                    onClick={this.toggleMobileFilters}
                    className="sidenav-close-btn"
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
                <div className="sidenav-content">
                  {/* Filter By */}
                  <div className="sidenav-filter-item">
                    <label>Filter By</label>
                    <Select
                      id="filterby-mobile"
                      name="filterby"
                      className="filter-select filter-box"
                      value={filterby}
                      onChange={this.handlePatientSorting}
                      displayEmpty
                      variant="outlined"
                      fullWidth
                    >
                      <MenuItem value="">Select</MenuItem>
                      {this.state.filterList.length ? (
                        this.state.filterList.map((facility) => (
                          <MenuItem key={facility.key} value={facility.key}>
                            {facility.value}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value=" ">Not Available</MenuItem>
                      )}
                    </Select>
                  </div>

                  {/* Sort By */}
                  <div className="sidenav-filter-item">
                    <label>Sort By</label>
                    <Select
                      id="filter-mobile"
                      name="filter"
                      className="filter-select filter-box"
                      value={filter}
                      onChange={this.handlePatientSorting}
                      displayEmpty
                      variant="outlined"
                      fullWidth
                    >
                      <MenuItem value="createdDateTime">Created Date</MenuItem>
                      <MenuItem value="refferalId">Referral ID</MenuItem>
                    </Select>
                  </div>

                  {/* Order By */}
                  <div className="sidenav-filter-item">
                    <label>Order By</label>
                    <Select
                      id="sorting-mobile"
                      name="sorting"
                      className="filter-select filter-box"
                      value={sorting}
                      onChange={this.handlePatientSorting}
                      displayEmpty
                      variant="outlined"
                      fullWidth
                    >
                      <MenuItem value="asc">ASC</MenuItem>
                      <MenuItem value="desc">DESC</MenuItem>
                    </Select>
                  </div>

                  {/* Insurance */}
                  <div className="sidenav-filter-item">
                    <label>Insurance</label>
                    <Select
                      id="filterbyinsuranceId-mobile"
                      name="filterbyinsuranceId"
                      className="filter-select filter-box"
                      value={filterbyinsuranceId}
                      onChange={this.handlePatientSorting}
                      displayEmpty
                      variant="outlined"
                      fullWidth
                    >
                      <MenuItem value="">Select</MenuItem>
                      {this.state.insuranceList.length ? (
                        this.state.insuranceList.map((insurance) => (
                          <MenuItem
                            key={insurance.insuranceId}
                            value={insurance.insuranceId}
                          >
                            {insurance.insuranceName}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value=" ">Not Available</MenuItem>
                      )}
                    </Select>
                  </div>
                </div>
              </div>

              {/* ===== DESKTOP FILTERS - Original filters, hidden on mobile ===== */}
              <Box
                display="flex"
                flexDirection="row"
                margin={"10px"}
                className="filters-row desktop-filters"
                alignItems={"center"}
              >
                {/* All Referral Title */}
                <Box marginRight={"30px"}>
                  <span className="titlename">All Referrals</span>
                </Box>

                {/* Total Referral Count */}
                <Box minWidth="120px">
                  <span className="show-text">
                    {totalPatientShowing}/{total} Referral
                    {total !== 1 ? "s" : ""}
                  </span>
                </Box>

                {/* Search Box */}
                <Box
                  marginRight={"15px"}
                  minWidth="150px"
                  className="search-box-wrapper"
                >
                  <ClickAwayListener
                    onClickAway={() =>
                      this.setState({ tooltipSearchOpen: false })
                    }
                  >
                    <Tooltip
                      title="Search By Referral ID, Facility Name, Patient Name"
                      placement="top"
                      arrow
                      open={this.state.tooltipSearchOpen}
                      onClose={() =>
                        this.setState({ tooltipSearchOpen: false })
                      }
                      onOpen={() => this.setState({ tooltipSearchOpen: true })}
                      disableFocusListener
                      disableTouchListener
                    >
                      <Paper
                        component="form"
                        className="search-box-cover filter-box"
                        onTouchStart={() =>
                          this.setState({ tooltipSearchOpen: true })
                        }
                        onMouseEnter={() =>
                          this.setState({ tooltipSearchOpen: true })
                        }
                        onMouseLeave={() =>
                          this.setState({ tooltipSearchOpen: false })
                        }
                      >
                        <InputBase
                          className="search-box"
                          placeholder="Search Referral"
                          onChange={this.search}
                          onKeyPress={this.searchReturn}
                        />
                        <IconButton
                          aria-label="search"
                          style={{ padding: "5px" }}
                          onClick={this.fetchPatients}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Paper>
                    </Tooltip>
                  </ClickAwayListener>
                </Box>

                {/* Desktop Filter Dropdowns Container */}
                <Box
                  className="filter-dropdowns-container"
                  display="flex"
                  flexDirection="row"
                  flexWrap="wrap"
                  alignItems="center"
                >
                  {/* Filter By */}
                  <Box className="box-filter-ref filter-1" minWidth="140px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2A2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Filter By
                        </InputLabel>
                        <Select
                          id="filterby"
                          name="filterby"
                          className="filter-select filter-box"
                          value={filterby}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="">Select</MenuItem>
                          {this.state.filterList.length ? (
                            this.state.filterList.map((facility) => (
                              <MenuItem key={facility.key} value={facility.key}>
                                {facility.value}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value=" ">Not Available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>

                  {/* Sort By (Created Date) */}
                  <Box className="box-filter-ref filter-2" minWidth="140px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2A2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Sort By
                        </InputLabel>
                        <Select
                          id="filter"
                          name="filter"
                          className="filter-select filter-box"
                          value={filter}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="createdDateTime">
                            Created Date
                          </MenuItem>
                          <MenuItem value="refferalId">Referral ID</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>

                  {/* Order By (DESC) */}
                  <Box className="box-filter-ref filter-3" minWidth="140px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2A2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Order By
                        </InputLabel>
                        <Select
                          id="sorting"
                          name="sorting"
                          className="filter-select filter-box"
                          value={sorting}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="asc">ASC</MenuItem>
                          <MenuItem value="desc">DESC</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>

                  {/* Insurance */}
                  <Box className="box-filter-ref filter-4" minWidth="140px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2AA2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Insurance
                        </InputLabel>
                        <Select
                          id="filterbyinsuranceId"
                          name="filterbyinsuranceId"
                          className="filter-select filter-box"
                          value={filterbyinsuranceId}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="">Select</MenuItem>
                          {this.state.insuranceList.length ? (
                            this.state.insuranceList.map((insurance) => (
                              <MenuItem
                                key={insurance.insuranceId}
                                value={insurance.insuranceId}
                              >
                                {insurance.insuranceName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value=" ">Not Available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>
                  {/* End of Filter Dropdowns Container */}
                </Box>
              </Box>

              {/* ===== Small Laptop FILTERS - Original filters, hidden on mobile, hidden on desktop ===== */}
              <Box
                display="flex"
                flexDirection="row"
                margin={"10px"}
                className="filters-row laptop-filters"
                alignItems={"center"}
              >
                {/* All Referral Title */}
                <Box marginRight={"15px"}>
                  <span className="titlename">All Referrals</span><br />
                  <span className="show-text">
                    {totalPatientShowing}/{total} Referral
                    {total !== 1 ? "s" : ""}
                  </span>
                </Box>

                {/* Search Box */}
                <Box
                  marginRight={"15px"}
                  minWidth="125px"
                  className="search-box-wrapper"
                >
                  <ClickAwayListener
                    onClickAway={() =>
                      this.setState({ tooltipSearchOpen: false })
                    }
                  >
                    <Tooltip
                      title="Search By Referral ID, Facility Name, Patient Name"
                      placement="top"
                      arrow
                      open={this.state.tooltipSearchOpen}
                      onClose={() =>
                        this.setState({ tooltipSearchOpen: false })
                      }
                      onOpen={() => this.setState({ tooltipSearchOpen: true })}
                      disableFocusListener
                      disableTouchListener
                    >
                      <Paper
                        component="form"
                        className="search-box-cover filter-box"
                        onTouchStart={() =>
                          this.setState({ tooltipSearchOpen: true })
                        }
                        onMouseEnter={() =>
                          this.setState({ tooltipSearchOpen: true })
                        }
                        onMouseLeave={() =>
                          this.setState({ tooltipSearchOpen: false })
                        }
                      >
                        <InputBase
                          className="search-box"
                          placeholder="Search Referral"
                          onChange={this.search}
                          onKeyPress={this.searchReturn}
                        />
                        <IconButton
                          aria-label="search"
                          style={{ padding: "5px" }}
                          onClick={this.fetchPatients}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Paper>
                    </Tooltip>
                  </ClickAwayListener>
                </Box>

                {/* Desktop Filter Dropdowns Container */}
                <Box
                  className="filter-dropdowns-container"
                  display="flex"
                  flexDirection="row"
                  flexWrap="wrap"
                  alignItems="center"
                >
                  {/* Filter By */}
                  <Box className="box-filter-ref filter-1" minWidth="125px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2A2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Filter By
                        </InputLabel>
                        <Select
                          id="filterby"
                          name="filterby"
                          className="filter-select filter-box"
                          value={filterby}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="">Select</MenuItem>
                          {this.state.filterList.length ? (
                            this.state.filterList.map((facility) => (
                              <MenuItem key={facility.key} value={facility.key}>
                                {facility.value}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value=" ">Not Available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>

                  {/* Sort By (Created Date) */}
                  <Box className="box-filter-ref filter-2" minWidth="125px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2A2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Sort By
                        </InputLabel>
                        <Select
                          id="filter"
                          name="filter"
                          className="filter-select filter-box"
                          value={filter}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="createdDateTime">
                            Created Date
                          </MenuItem>
                          <MenuItem value="refferalId">Referral ID</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>

                  {/* Order By (DESC) */}
                  <Box className="box-filter-ref filter-3" minWidth="125px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2A2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Order By
                        </InputLabel>
                        <Select
                          id="sorting"
                          name="sorting"
                          className="filter-select filter-box"
                          value={sorting}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="asc">ASC</MenuItem>
                          <MenuItem value="desc">DESC</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>

                  {/* Insurance */}
                  <Box className="box-filter-ref filter-4" minWidth="125px">
                    <FormGroup>
                      <FormControl variant="outlined" size="small">
                        <InputLabel
                          shrink={false}
                          style={{
                            position: "static",
                            transform: "none",
                            marginBottom: "6px",
                            color: "#2A2AA2A !important",
                            fontSize: "11px",
                            fontWeight: 500,
                          }}
                        >
                          Insurance
                        </InputLabel>
                        <Select
                          id="filterbyinsuranceId"
                          name="filterbyinsuranceId"
                          className="filter-select filter-box"
                          value={filterbyinsuranceId}
                          onChange={this.handlePatientSorting}
                          displayEmpty
                        >
                          <MenuItem value="">Select</MenuItem>
                          {this.state.insuranceList.length ? (
                            this.state.insuranceList.map((insurance) => (
                              <MenuItem
                                key={insurance.insuranceId}
                                value={insurance.insuranceId}
                              >
                                {insurance.insuranceName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value=" ">Not Available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Box>
                  {/* End of Filter Dropdowns Container */}
                </Box>
              </Box>
            </div>

            <Box
              display="flex"
              flexDirection="row"
              width={1}
              className={`patient-list-page AllReferrals-page ${
                window.innerWidth <= 991 && this.state.mobileContentViewerOpen
                  ? "content-viewer-active"
                  : ""
              }`}
            >
              <Box
                pr={1.5}
                className={`left-content-box-ref part-1`}
                style={{
                  width: this.state.contentViewerOpen
                    ? window.innerWidth <= 1440 && window.innerWidth > 1024
                      ? "25%"
                      : "15%"
                    : "50%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Box width={1} className="left-content-list">
                  <div className="PatientList">
                    <Scrollbars
                      className="ref-scrollbox-1"
                      universal={true}
                      autoHide={false}
                    >
                      {patientList &&
                      typeof patientList === "object" &&
                      patientList.length ? (
                        <InfiniteScroll
                          pageStart={0}
                          loadMore={this.loadMorePatient}
                          threshold={50}
                          hasMore={this.state.loadMore}
                          loader={
                            <div className="loader" key={0}>
                              Loading ...
                            </div>
                          }
                          useWindow={false}
                          getScrollParent={() => this.scrollParentRef}
                        >
                          {patientList.length &&
                            patientList.map((referralPatient, key) => (
                              <Box
                                width={1}
                                display="flex"
                                flexDirection="row"
                                mb={2}
                                pr={2}
                                key={key}
                                className="id_box"
                              >
                                <div
                                  className={`pointer list-item-content-Ref ${selectedPatientData.id ==
                                    referralPatient.id && `selected-Ref`}`}
                                  onClick={() =>
                                    this.selectPatientDetail(
                                      referralPatient.id,
                                      referralPatient.refferalId,
                                      key,
                                    )
                                  }
                                >
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    alignItems="center"
                                    width={
                                      this.state.contentViewerOpen
                                        ? "100%"
                                        : "70%"
                                    }
                                    justifyContent={"space-between"}
                                    className="name-column"
                                  >
                                    {/* Left Section: Facility, Referral ID, Received Date, Category, and Patients (in 3-column mode) */}
                                    <Box
                                      pr={2}
                                      // width={
                                      //   this.state.contentViewerOpen ? 1 : 1
                                      // }
                                      className="pointer"
                                      // display="flex"
                                      // flexDirection="column"
                                    >
                                      <div className="facility-name">
                                        {referralPatient.facilityName ||
                                          (referralPatient.dischargeplannerEntity &&
                                            referralPatient.dischargeplannerEntity
                                              .facility.facilityName)}
                                      </div>
                                      {/* <div className="referral-id">
                                        Referral ID:{" "}
                                        {referralPatient.refferalId}
                                      </div> */}
                                      <div className="received-date">
                                        {/* <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="8.75"
                                          height="10"
                                          viewBox="0 0 8.75 10"
                                          style={{
                                            marginRight: "4px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <path
                                            id="calendar-alt"
                                            d="M8.516,3.125H.234A.235.235,0,0,1,0,2.891v-.7A.938.938,0,0,1,.938,1.25h.938V.234A.235.235,0,0,1,2.109,0h.781a.235.235,0,0,1,.234.234V1.25h2.5V.234A.235.235,0,0,1,5.859,0h.781a.235.235,0,0,1,.234.234V1.25h.938a.938.938,0,0,1,.938.938v.7A.235.235,0,0,1,8.516,3.125ZM.234,3.75H8.516a.235.235,0,0,1,.234.234V9.063A.938.938,0,0,1,7.813,10H.938A.938.938,0,0,1,0,9.063V3.984A.235.235,0,0,1,.234,3.75ZM2.5,7.734A.235.235,0,0,0,2.266,7.5H1.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,2.5,8.516Zm0-2.5A.235.235,0,0,0,2.266,5H1.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,2.5,6.016ZM5,7.734A.235.235,0,0,0,4.766,7.5H3.984a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,5,8.516Zm0-2.5A.235.235,0,0,0,4.766,5H3.984a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,5,6.016Zm2.5,2.5A.235.235,0,0,0,7.266,7.5H6.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,7.5,8.516Zm0-2.5A.235.235,0,0,0,7.266,5H6.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,7.5,6.016Z"
                                            fill="#666"
                                          />
                                        </svg> */}
                                        Received:{" "}
                                        {this.dateUtility.format(
                                          new Date(
                                            referralPatient.refferalSendTime,
                                          ),
                                          "MM/dd/yyyy",
                                        )}
                                      </div>
                                      <div className="category">
                                        {/* <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          style={{ marginRight: "4px" }}
                                        >
                                          <path
                                            d="M0,1.25A1.25,1.25,0,0,1,1.25,0h5a1.25,1.25,0,0,1,.884.366l2.5,2.5A1.25,1.25,0,0,1,10,3.75v5A1.25,1.25,0,0,1,8.75,10H1.25A1.25,1.25,0,0,1,0,8.75ZM2.5,3.75A.625.625,0,1,0,3.125,3.125.625.625,0,0,0,2.5,3.75Z"
                                            fill="#666"
                                          />
                                        </svg> */}
                                        {/* Category:{" "} */}
                                        {referralPatient.categoryId &&
                                          this.state.categoryList.map((el) => {
                                            if (
                                              el.id ==
                                              referralPatient.categoryId
                                            ) {
                                              return el.categoryValue;
                                            }
                                          })}
                                      </div>

                                      {/* Patient info shown below category in 3-column mode or responsive mode */}
                                      {(this.state.contentViewerOpen ||
                                        window.innerWidth <= 991) && (
                                        <Box mt={0.5}>
                                          {referralPatient.refferalPatientEntity &&
                                          referralPatient.refferalPatientEntity
                                            .length > 0 ? (
                                            referralPatient
                                              .refferalPatientEntity.length >
                                            1 ? (
                                              <div
                                                style={{
                                                  fontSize: "13px",
                                                  color: "#333",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  minWidth: 0, // IMPORTANT for flex
                                                  maxWidth: "100%", // or a fixed width like "150px"
                                                }}
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="15"
                                                  height="15"
                                                  viewBox="0 0 10 10"
                                                  style={{ marginRight: "4px" }}
                                                >
                                                  <path
                                                    d="M5,5.625A1.875,1.875,0,1,0,3.125,3.75,1.875,1.875,0,0,0,5,5.625Zm0,0.938c-1.25,0-3.75,0.628-3.75,1.875V9.375H8.75V8.438C8.75,7.191,6.25,6.563,5,6.563Z"
                                                    fill="#666"
                                                  />
                                                </svg>
                                                Patients: Multiple (
                                                {
                                                  referralPatient
                                                    .refferalPatientEntity
                                                    .length
                                                }
                                                )
                                              </div>
                                            ) : (
                                              <Box
                                                display="flex"
                                                flexDirection="column"
                                              >
                                                <div
                                                  style={{
                                                    fontSize: "13px",
                                                    color: "#333",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    minWidth: 0, // IMPORTANT for flex
                                                    maxWidth: "100%", // or a fixed width like "150px"
                                                  }}
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="15"
                                                    height="15"
                                                    viewBox="0 0 10 10"
                                                    style={{
                                                      marginRight: "4px",
                                                    }}
                                                  >
                                                    <path
                                                      d="M5,5.625A1.875,1.875,0,1,0,3.125,3.75,1.875,1.875,0,0,0,5,5.625Zm0,0.938c-1.25,0-3.75,0.628-3.75,1.875V9.375H8.75V8.438C8.75,7.191,6.25,6.563,5,6.563Z"
                                                      fill="#666"
                                                    />
                                                  </svg>
                                                  <div
                                                    style={{
                                                      fontSize: "13px",
                                                      color: "#333",
                                                      whiteSpace: "nowrap",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                      width: "80%",
                                                    }}
                                                  >
                                                    Name:{" "}
                                                    {referralPatient
                                                      .refferalPatientEntity[0]
                                                      .patientEntity.lastName &&
                                                      referralPatient
                                                        .refferalPatientEntity[0]
                                                        .patientEntity
                                                        .lastName + ", "}
                                                    {referralPatient
                                                      .refferalPatientEntity[0]
                                                      .patientEntity
                                                      .firstName || "N/A"}
                                                  </div>
                                                </div>
                                                {/* DOB - only show when document viewer is open (desktop), hide on mobile */}
                                                {this.state
                                                  .contentViewerOpen && (
                                                  <div
                                                    style={{
                                                      fontSize: "13px",
                                                      color: "#666",
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="8.75"
                                                      height="10"
                                                      viewBox="0 0 8.75 10"
                                                      style={{
                                                        marginRight: "4px",
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      <path
                                                        id="calendar-alt"
                                                        d="M8.516,3.125H.234A.235.235,0,0,1,0,2.891v-.7A.938.938,0,0,1,.938,1.25h.938V.234A.235.235,0,0,1,2.109,0h.781a.235.235,0,0,1,.234.234V1.25h2.5V.234A.235.235,0,0,1,5.859,0h.781a.235.235,0,0,1,.234.234V1.25h.938a.938.938,0,0,1,.938.938v.7A.235.235,0,0,1,8.516,3.125ZM.234,3.75H8.516a.235.235,0,0,1,.234.234V9.063A.938.938,0,0,1,7.813,10H.938A.938.938,0,0,1,0,9.063V3.984A.235.235,0,0,1,.234,3.75ZM2.5,7.734A.235.235,0,0,0,2.266,7.5H1.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,2.5,8.516Zm0-2.5A.235.235,0,0,0,2.266,5H1.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,2.5,6.016ZM5,7.734A.235.235,0,0,0,4.766,7.5H3.984a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,5,8.516Zm0-2.5A.235.235,0,0,0,4.766,5H3.984a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,5,6.016Zm2.5,2.5A.235.235,0,0,0,7.266,7.5H6.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,7.5,8.516Zm0-2.5A.235.235,0,0,0,7.266,5H6.484a.235.235,0,0,0-.234.234v.781a.235.235,0,0,0,.234.234h.781A.235.235,0,0,0,7.5,6.016Z"
                                                        fill="#666"
                                                      />
                                                    </svg>
                                                    DOB:{" "}
                                                    {referralPatient
                                                      .refferalPatientEntity[0]
                                                      .patientEntity.patientDob
                                                      ? this.dateUtility.format(
                                                          new Date(
                                                            referralPatient.refferalPatientEntity[0].patientEntity.patientDob,
                                                          ),
                                                          "MM/dd/yyyy",
                                                        )
                                                      : "N/A"}
                                                  </div>
                                                )}
                                              </Box>
                                            )
                                          ) : (
                                            <div
                                              style={{
                                                fontSize: "13px",
                                                color: "#999",
                                              }}
                                            >
                                              No patient data
                                            </div>
                                          )}
                                        </Box>
                                      )}
                                    </Box>

                                    {/* Middle Section: Status Badge with Date - Only shown in 2-column mode */}
                                    {!this.state.contentViewerOpen && (
                                      <Box
                                        pr={2}
                                        width={1 / 6}
                                        className="Ref-tags"
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="center"
                                        alignItems="center"
                                      >
                                        <div
                                          className={`tag ${
                                            referralPatient
                                              .refferalProviderEntity[0]
                                              .masterRefferalStatusEntity
                                              .refferalStatusValue &&
                                            referralPatient
                                              .refferalProviderEntity[0]
                                              .masterRefferalStatusEntity
                                              .refferalStatusValue
                                              ? referralPatient
                                                  .refferalProviderEntity[0]
                                                  .masterRefferalStatusEntity
                                                  .refferalStatusValue
                                              : "noStatus"
                                          }`}
                                        >
                                          {getStatusDisplayLabel(
                                            referralPatient
                                              .refferalProviderEntity[0]
                                              .masterRefferalStatusEntity
                                              .refferalStatusValue
                                          )}
                                        </div>
                                        <div
                                          className="tag-date"
                                          style={{
                                            fontSize: "12px",
                                            marginTop: "4px",
                                          }}
                                        >
                                          {referralPatient
                                            .refferalProviderEntity[0] &&
                                            this.dateUtility.format(
                                              new Date(
                                                referralPatient.refferalProviderEntity[0].formattedUpdatedDateTime,
                                              ),
                                              "MM/dd/yyyy",
                                            )}
                                        </div>
                                      </Box>
                                    )}
                                  </Box>
                                  <Box
                                    className="AllRef-content girish"
                                    display={
                                      this.state.contentViewerOpen
                                        ? "none"
                                        : "flex"
                                    }
                                    flexDirection="row"
                                    width={1}
                                    alignItems="stretch"
                                  >
                                    {/* Right Section: Patient Display - Only shown in 2-column mode */}

                                    {!this.state.contentViewerOpen && (
                                      <Box
                                        width={7 / 12}
                                        className="Ref-patients-table"
                                      >
                                        {referralPatient.refferalPatientEntity &&
                                        referralPatient.refferalPatientEntity
                                          .length > 0 ? (
                                          // 2-COLUMN LAYOUT (Viewer Closed): Show full patient table
                                          <Box
                                            display="flex"
                                            flexDirection="column"
                                            className="patients-table-inner-1"
                                          >
                                            {referralPatient.refferalPatientEntity.map(
                                              (patientItem, patientIndex) => (
                                                <Box
                                                  key={patientIndex}
                                                  display="flex"
                                                  flexDirection="row"
                                                  justifiyContent="space-between"
                                                  py={0.5}
                                                  borderBottom={
                                                    patientIndex <
                                                    referralPatient
                                                      .refferalPatientEntity
                                                      .length -
                                                      1
                                                      ? "1px solid #eee"
                                                      : "none"
                                                  }
                                                >
                                                  <Box width={"36%"} pr={1}>
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      style={{ gap: "6px" }}
                                                    >
                                                      <img
                                                        src={PatientIcon}
                                                        alt=""
                                                        style={{
                                                          width: "16px",
                                                          height: "16px",
                                                        }}
                                                      />
                                                      <div
                                                        style={{
                                                          fontSize: "14px",
                                                          color: "#2B2B2B",
                                                          maxWidth: "60%",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                          // whiteSpace: "nowrap",
                                                          cursor: "pointer",
                                                        }}
                                                        className="patients-table-inner-patient-name"
                                                        title={
                                                          (patientItem
                                                            .patientEntity
                                                            .lastName
                                                            ? patientItem
                                                                .patientEntity
                                                                .lastName + ", "
                                                            : "") +
                                                          (patientItem
                                                            .patientEntity
                                                            .firstName || "N/A")
                                                        }
                                                      >
                                                        {patientItem
                                                          .patientEntity
                                                          .lastName &&
                                                          patientItem
                                                            .patientEntity
                                                            .lastName + ", "}
                                                        {patientItem
                                                          .patientEntity
                                                          .firstName || "N/A"}
                                                      </div>
                                                    </Box>
                                                  </Box>
                                                  <Box width={"28%"} pr={1}>
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      style={{ gap: "6px" }}
                                                    >
                                                      <img
                                                        src={PatientDateIcon}
                                                        alt=""
                                                        style={{
                                                          width: "16px",
                                                          height: "16px",
                                                        }}
                                                      />
                                                      <div
                                                        style={{
                                                          fontSize: "14px",
                                                          color: "#2B2B2B",
                                                          maxWidth: "60%",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                          // whiteSpace: "nowrap",
                                                          cursor: "pointer",
                                                        }}
                                                        className="patients-table-inner-patient-dob"
                                                        title={
                                                          patientItem
                                                            .patientEntity
                                                            .patientDob
                                                            ? this.dateUtility.format(
                                                                new Date(
                                                                  patientItem.patientEntity.patientDob,
                                                                ),
                                                                "MM/dd/yyyy",
                                                              )
                                                            : "N/A"
                                                        }
                                                      >
                                                        {patientItem
                                                          .patientEntity
                                                          .patientDob
                                                          ? this.dateUtility.format(
                                                              new Date(
                                                                patientItem.patientEntity.patientDob,
                                                              ),
                                                              "MM/dd/yyyy",
                                                            )
                                                          : "N/A"}
                                                      </div>
                                                    </Box>
                                                  </Box>
                                                  <Box width={"36%"}>
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      style={{ gap: "6px" }}
                                                    >
                                                      <img
                                                        src={
                                                          PatientDepartmentIcon
                                                        }
                                                        alt=""
                                                        style={{
                                                          width: "16px",
                                                          height: "16px",
                                                        }}
                                                      />
                                                      <div
                                                        style={{
                                                          fontSize: "14px",
                                                          color: "#2B2B2B",
                                                          maxWidth: "60%",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                          // whiteSpace: "nowrap",
                                                          cursor: "pointer",
                                                        }}
                                                        className="patients-table-inner-patient-insurance"
                                                        title={
                                                          patientItem
                                                            .patientEntity
                                                            .masterInsurance &&
                                                          patientItem
                                                            .patientEntity
                                                            .masterInsurance
                                                            .insuranceName
                                                            ? patientItem
                                                                .patientEntity
                                                                .masterInsurance
                                                                .insuranceName
                                                            : "No Insurance"
                                                        }
                                                      >
                                                        {patientItem
                                                          .patientEntity
                                                          .masterInsurance &&
                                                        patientItem
                                                          .patientEntity
                                                          .masterInsurance
                                                          .insuranceName
                                                          ? patientItem
                                                              .patientEntity
                                                              .masterInsurance
                                                              .insuranceName
                                                          : "No Insurance"}
                                                      </div>
                                                    </Box>
                                                  </Box>
                                                </Box>
                                              ),
                                            )}
                                          </Box>
                                        ) : (
                                          <div
                                            style={{
                                              fontSize: "13px",
                                              color: "#999",
                                            }}
                                          >
                                            No patient data
                                          </div>
                                        )}
                                      </Box>
                                    )}
                                  </Box>
                                </div>
                              </Box>
                            ))}
                        </InfiniteScroll>
                      ) : this.state.loadingPatient ? (
                        <div className="no-data-div">
                          <div>Loading...</div>
                        </div>
                      ) : (
                        <div className="no-data-div">
                          {" "}
                          <div className="referal_avail">
                            No referral available{" "}
                          </div>
                        </div>
                      )}
                    </Scrollbars>
                  </div>
                </Box>
              </Box>
              <Box
                className={`left-content-box-ref part-2 patient_bottom${
                  this.state.mobileReferralPopupOpen
                    ? " mobile-popup-active"
                    : ""
                }`}
                style={{
                  width: this.state.contentViewerOpen ? "85%" : "50%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                {/* Mobile popup close button */}
                {this.state.mobileReferralPopupOpen && (
                  <button
                    className="mobile-popup-close"
                    onClick={this.closeMobileReferralPopup}
                    aria-label="Close referral details"
                  >
                    <ArrowBackIcon style={{ fontSize: 20, color: "#333" }} />
                  </button>
                )}
                {/* Mobile popup overlay - click to close */}
                {this.state.mobileReferralPopupOpen && (
                  <div
                    className="mobile-popup-overlay"
                    onClick={this.closeMobileReferralPopup}
                  />
                )}
                <div
                  className="referral-right-box1"
                  style={{
                    marginTop: "0px !important",
                    display: "flex",
                    flexDirection: "row",
                    gap: this.state.contentViewerOpen ? "12px" : "0px",
                  }}
                >
                  {/* Left side - Referral Details */}
                  <Box
                    className="referral-right-content-box"
                    style={{
                      width: this.state.contentViewerOpen ? "50%" : "100%",
                      transition: "width 0.3s ease-in-out",
                      overflow: "hidden",
                      margin: "auto",
                      display:
                        window.innerWidth <= 1024 &&
                        this.state.contentViewerOpen
                          ? "none"
                          : "block",
                    }}
                  >
                    {selectedPatientData ? (
                      <div className="referral-right-content">
                        <Box
                          display="flex"
                          flexDirection="row"
                          width={1}
                          mb={2}
                          className="referral-right-header"
                        >
                          <div className="id-tag">
                            <h3 className="ref-id">
                              Referral ID : {selectedPatientData.refferalId}
                            </h3>
                            <div
                              className={`current-status tag ${
                                selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity
                                  .refferalStatusValue === "Acknowledged"
                                  ? "Acknowledged"
                                  : selectedPatientData
                                      .refferalProviderEntity[0]
                                      .masterRefferalStatusEntity
                                      .refferalStatusValue === "Pending"
                                  ? "Pending"
                                  : selectedPatientData
                                      .refferalProviderEntity[0]
                                      .masterRefferalStatusEntity
                                      .refferalStatusValue === "Dropped"
                                  ? "Dropped"
                                  : ""
                              }`}
                            >
                              {getStatusDisplayLabel(
                                selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity
                                  .refferalStatusValue
                              )}
                            </div>
                            {/* <div className="tag-date-right">
                            {selectedPatientData.refferalProviderEntity[0]
                              .masterRefferalStatusEntity.id !== 4 &&
                              selectedPatientData.refferalProviderEntity[0]
                                .formattedUpdatedDateTime}
                          </div> */}
                            <div className="facname">
                              Facility:{" "}
                              {selectedPatientData.facilityName ||
                                (selectedPatientData.dischargeplannerEntity &&
                                selectedPatientData.dischargeplannerEntity
                                  .facility.facilityName
                                  ? selectedPatientData.dischargeplannerEntity
                                      .facility.facilityName
                                  : "")}
                            </div>
                          </div>
                          <div
                            className="id-date"
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "16px",
                            }}
                          >
                            {/* Export Button - LEFT of Referral Received */}
                            <div className="export-referral-btn">
                              <Button
                                className="export-btn"
                                onClick={this.handleExportClick}
                                startIcon={<GetAppIcon />}
                              >
                                Export
                              </Button>
                              <Menu
                                anchorEl={this.state.exportMenuAnchor}
                                open={Boolean(this.state.exportMenuAnchor)}
                                onClose={this.handleExportClose}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                              >
                                <MenuItem onClick={this.handleExportCSV}>
                                  CSV
                                </MenuItem>
                                <MenuItem onClick={this.handleExportHL7}>
                                  HL7
                                </MenuItem>
                                <MenuItem onClick={this.handleExportJSON}>
                                  JSON
                                </MenuItem>
                                <MenuItem onClick={this.handleExportXML}>
                                  XML (Clinical Summary)
                                </MenuItem>
                              </Menu>
                            </div>

                            {/* Original Referral Received section */}
                            <div>
                              <div className="extended-info">
                                Referral Received
                              </div>
                              <div className="extended-date">
                                {this.dateUtility.format(
                                  new Date(
                                    selectedPatientData.refferalSendTime,
                                  ),
                                  "MM/dd/yyyy",
                                )}
                              </div>
                            </div>
                          </div>
                        </Box>
                        <div className="id-tag">
                          <h3 className="ref-id">
                            Referral Type -{" "}
                            <span className="patient_ref_text">
                              {REFERRAL_TYPES[selectedPatientData.refferalType]}
                            </span>
                            {
                              <ClickAwayListener
                                onClickAway={() =>
                                  this.setState({
                                    tooltipPreliminaryOpen: false,
                                  })
                                }
                              >
                                <Tooltip
                                  title={
                                    <div style={{ fontSize: 13, padding: 8 }}>
                                      <strong>
                                        {selectedPatientData.refferalType == 1
                                          ? "This is a preliminary referral."
                                          : "Rapid Referrals operate on a first-come, first-served basis. "}
                                      </strong>{" "}
                                      {selectedPatientData.refferalType == 1
                                        ? "A discharge planner will later finalize it to you or drop it based on the family's decision. Dropped referrals need no action and may occur due to family preference, another provider accepting first, or the service no longer being required."
                                        : "When a referral is broadcast to multiple providers, the first one to accept is automatically Finalized as the assigned provider. Consequently, all other pending requests are immediately Dropped."}
                                    </div>
                                  }
                                  placement="right"
                                  arrow
                                  open={this.state.tooltipPreliminaryOpen}
                                  onClose={() =>
                                    this.setState({
                                      tooltipPreliminaryOpen: false,
                                    })
                                  }
                                  onOpen={() =>
                                    this.setState({
                                      tooltipPreliminaryOpen: true,
                                    })
                                  }
                                  disableFocusListener
                                  disableTouchListener
                                >
                                  <InfoOutlinedIcon
                                    style={{
                                      fontSize: 24,
                                      marginLeft: 6,
                                      color: "#FF0000",
                                      cursor: "pointer",
                                      verticalAlign: "middle",
                                    }}
                                    onTouchStart={() =>
                                      this.setState({
                                        tooltipPreliminaryOpen: true,
                                      })
                                    }
                                    onMouseEnter={() =>
                                      this.setState({
                                        tooltipPreliminaryOpen: true,
                                      })
                                    }
                                    onMouseLeave={() =>
                                      this.setState({
                                        tooltipPreliminaryOpen: false,
                                      })
                                    }
                                  />
                                </Tooltip>
                              </ClickAwayListener>
                            }
                          </h3>
                        </div>

                        <div className="bottom_dashbox">
                          <Scrollbars
                            className="ref-scrollbox new_div g-new-div"
                            style={{ height: "calc(100vh - 495px)" }}
                            universal={true}
                            autoHide={false}
                          >
                            {selectedPatientData.refferalPatientEntity[0] ? (
                              <Box
                                width={1}
                                display="flex"
                                flexDirection="column"
                                mb={2}
                                // pr={1.5}
                                className="id_box"
                              >
                                {selectedPatientData.refferalPatientEntity.map(
                                  (patient, key) => (
                                    <Box
                                      key={key}
                                      style={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 8,
                                        padding: "16px",
                                        marginBottom: 16,
                                      }}
                                      className="id-box-inner-1"
                                    >
                                      {/* Patient Header: Name on left, Category & Accepted date on right */}
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="flex-start"
                                        mb={2}
                                        className="id-box-header-2"
                                      >
                                        <Box flex={1}>
                                          <Typography
                                            variant="h6"
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: 20,
                                              color: "#333",
                                              marginBottom: 8,
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {patient.patientEntity.lastName &&
                                              patient.patientEntity.lastName +
                                                ", "}
                                            {patient.patientEntity.firstName}
                                          </Typography>

                                          {/* Hide patient details for Preliminary Referrals until acknowledged */}
                                          {!(
                                            selectedPatientData.refferalType ==
                                              1 &&
                                            selectedPatientData
                                              .refferalProviderEntity[0]
                                              .masterRefferalStatusEntity
                                              .refferalStatusValue === "Pending"
                                          ) && (
                                            <>
                                              {/* Discharged Date with Icon */}
                                              <Box
                                                display="flex"
                                                alignItems="center"
                                                mb={1}
                                              >
                                                <EventIcon
                                                  style={{
                                                    fontSize: 16,
                                                    color: "#000",
                                                    marginRight: 6,
                                                  }}
                                                />
                                                <Typography
                                                  variant="body2"
                                                  style={{
                                                    fontSize: 14,
                                                    color: "#000",
                                                  }}
                                                >
                                                  {patient.patientEntity
                                                    .actualDischargeDate
                                                    ? "Discharged: "
                                                    : "Est Discharge: "}
                                                  {patient.patientEntity
                                                    .actualDischargeDate
                                                    ? this.dateUtility.format(
                                                        new Date(
                                                          patient.patientEntity.actualDischargeDate,
                                                        ),
                                                        "MM/dd/yyyy",
                                                      )
                                                    : patient.patientEntity
                                                        .formattedEstimatedDischargeDate
                                                    ? this.dateUtility.format(
                                                        new Date(
                                                          patient.patientEntity.formattedEstimatedDischargeDate,
                                                        ),
                                                        "MM/dd/yyyy",
                                                      )
                                                    : "N/A"}
                                                </Typography>
                                              </Box>

                                              {/* Insurance with Icon */}
                                              <Box
                                                display="flex"
                                                alignItems="center"
                                              >
                                                <LocalHospitalIcon
                                                  style={{
                                                    fontSize: 16,
                                                    color: "#000",
                                                    marginRight: 6,
                                                  }}
                                                />
                                                <Typography
                                                  variant="body2"
                                                  style={{
                                                    fontSize: 14,
                                                    color: "#000",
                                                  }}
                                                >
                                                  Insurance:{" "}
                                                  {this.state.insuranceList.map(
                                                    (insuranceList) =>
                                                      insuranceList.insuranceId ==
                                                        patient.patientEntity
                                                          .insuranceId &&
                                                      insuranceList.insuranceName,
                                                  )}
                                                </Typography>
                                              </Box>
                                            </>
                                          )}
                                        </Box>

                                        {/* Category Badge and Accepted Date on Right */}
                                        <Box
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="flex-end"
                                        >
                                          <Box
                                            style={{
                                              backgroundColor: "#7DBDD9",
                                              color: "#000",
                                              padding: "2px 12px",
                                              borderRadius: 12,
                                              fontSize: 12,
                                              fontWeight: "bold",
                                              marginBottom: 8,
                                            }}
                                          >
                                            {selectedPatientData.categoryId &&
                                              this.state.categoryList.map(
                                                (el) => {
                                                  if (
                                                    el.id ==
                                                    selectedPatientData.categoryId
                                                  ) {
                                                    return el.categoryValue;
                                                  }
                                                },
                                              )}
                                          </Box>
                                          {selectedPatientData
                                            .refferalProviderEntity[0]
                                            ?.masterRefferalStatusEntity
                                            ?.refferalStatusValue !==
                                            "Pending" && (
                                            <Typography
                                              variant="body2"
                                              style={{
                                                fontSize: 13,
                                                fontWeight: "regular",
                                                color: "#666",
                                              }}
                                            >
                                              Accepted:{" "}
                                              {selectedPatientData
                                                .refferalProviderEntity[0] &&
                                                this.dateUtility.format(
                                                  new Date(
                                                    selectedPatientData.refferalProviderEntity[0].formattedUpdatedDateTime,
                                                  ),
                                                  "MM/dd/yyyy HH:mm:ss",
                                                )}
                                            </Typography>
                                          )}
                                        </Box>
                                      </Box>

                                      {/* Acknowledgment message for Preliminary Referrals in Pending status */}
                                      {selectedPatientData.refferalType == 1 &&
                                        selectedPatientData
                                          .refferalProviderEntity[0]
                                          .masterRefferalStatusEntity
                                          .refferalStatusValue ===
                                          "Pending" && (
                                          <Box
                                            style={{
                                              backgroundColor: "#FFF9E6",
                                              border: "1px solid #F5C518",
                                              borderRadius: 8,
                                              padding: "16px",
                                              marginTop: 16,
                                              textAlign: "center",
                                            }}
                                          >
                                            <Typography
                                              style={{
                                                color: "#333",
                                                fontSize: 14,
                                              }}
                                            >
                                              Please Acknowledge Receipt of this
                                              referral to view the patient's
                                              details. This only confirms
                                              receipt — you'll decide whether to
                                              accept or decline after reviewing.
                                            </Typography>
                                          </Box>
                                        )}

                                      {/* For non-Dropped status: Show AI Insights & Documents (hidden for Transport/DME categories and Pending Preliminary) */}
                                      {selectedPatientData
                                        .refferalProviderEntity[0]
                                        .masterRefferalStatusEntity
                                        .refferalStatusValue !== "Dropped" &&
                                        !(
                                          selectedPatientData.refferalType ==
                                            1 &&
                                          selectedPatientData
                                            .refferalProviderEntity[0]
                                            .masterRefferalStatusEntity
                                            .refferalStatusValue === "Pending"
                                        ) &&
                                        !selectedPatientData.refferalTransportEntity &&
                                        !selectedPatientData.refferalDmeEntity &&
                                        !["transport", "dme"].includes(
                                          this.state.selectedPatientCategoryValue?.toLowerCase(),
                                        ) && (this.isReferralAccessAllowed() ? (
                                          <>
                                            {/* AI Referral Insights */}
                                            <Box
                                              style={{
                                                marginTop: 16,
                                                marginBottom: 16,
                                              }}
                                              className="ai-referral-box"
                                            >
                                              <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                style={{
                                                  background:
                                                    "linear-gradient(180deg, #FAF097 0%, #FAE977 50%, #F5D75B 75%, #FCD74B 100%)",
                                                  borderRadius: 25,
                                                  padding: "2px 12px",
                                                  boxShadow:
                                                    "0 2px 8px rgba(255, 215, 0, 0.2)",
                                                }}
                                              >
                                                <Box
                                                  display="flex"
                                                  alignItems="center"
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: 20,
                                                      marginRight: 8,
                                                    }}
                                                  >
                                                    <img
                                                      src={CrownIcon}
                                                      alt="Crown Icon"
                                                      width={25}
                                                      height={25}
                                                      className="crown-icon"
                                                    />
                                                  </span>
                                                  <Typography
                                                    style={{
                                                      fontWeight: "bold",
                                                      color: "#2A2A2A",
                                                      fontSize: 16,
                                                    }}
                                                  >
                                                    AI Referral Insights
                                                  </Typography>
                                                  <ClickAwayListener
                                                    onClickAway={() =>
                                                      this.setState({
                                                        tooltipAIInsightsOpen: false,
                                                      })
                                                    }
                                                  >
                                                    <Tooltip
                                                      title="AI-generated clinical support tool for reference only. Not a medical record."
                                                      placement="top"
                                                      arrow
                                                      open={
                                                        this.state
                                                          .tooltipAIInsightsOpen
                                                      }
                                                      onClose={() =>
                                                        this.setState({
                                                          tooltipAIInsightsOpen: false,
                                                        })
                                                      }
                                                      onOpen={() =>
                                                        this.setState({
                                                          tooltipAIInsightsOpen: true,
                                                        })
                                                      }
                                                      disableFocusListener
                                                      disableTouchListener
                                                    >
                                                      <InfoOutlinedIcon
                                                        style={{
                                                          fontSize: 16,
                                                          marginLeft: 6,
                                                          color: "#666",
                                                          cursor: "pointer",
                                                        }}
                                                        onTouchStart={() =>
                                                          this.setState({
                                                            tooltipAIInsightsOpen: true,
                                                          })
                                                        }
                                                        onMouseEnter={() =>
                                                          this.setState({
                                                            tooltipAIInsightsOpen: true,
                                                          })
                                                        }
                                                        onMouseLeave={() =>
                                                          this.setState({
                                                            tooltipAIInsightsOpen: false,
                                                          })
                                                        }
                                                      />
                                                    </Tooltip>
                                                  </ClickAwayListener>
                                                  <span
                                                    className="premium-badge"
                                                    style={{
                                                      backgroundColor:
                                                        "#6A0DAD",
                                                      color: "#FFFFFF",
                                                      padding: "0px 12px",
                                                      borderRadius: 20,
                                                      fontSize: 9,
                                                      fontWeight: "lighter",
                                                      marginLeft: 8,
                                                      marginBottom: 12,
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    PREMIUM
                                                  </span>
                                                </Box>
                                                {patient.patientEntity
                                                  ?.aiReferralSummaryStatus ===
                                                "AVAILABLE" ? (
                                                  <Box
                                                    display="flex"
                                                    alignItems="center"
                                                    gap={1}
                                                  >
                                                    <span
                                                      style={{
                                                        backgroundColor:
                                                          "#796D54",
                                                        color: "#FFFFFF",
                                                        padding: "2px 14px",
                                                        borderRadius: 16,
                                                        fontSize: 12,
                                                        fontWeight: "600",
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap",
                                                        marginRight: 8,
                                                      }}
                                                      onClick={() =>
                                                        this.handleViewAISummary(
                                                          patient.patientId,
                                                        )
                                                      }
                                                    >
                                                      Try Now !
                                                    </span>
                                                    <IconButton
                                                      onClick={() =>
                                                        this.handleViewAISummary(
                                                          patient.patientId,
                                                        )
                                                      }
                                                      disabled={
                                                        this.state.loadingViewer
                                                      }
                                                      title="View Summary"
                                                      style={{ padding: 6 }}
                                                    >
                                                      <img
                                                        src={EyeIcon}
                                                        alt="View"
                                                        style={{
                                                          width: 25,
                                                          height: 25,
                                                        }}
                                                      />
                                                    </IconButton>
                                                    <IconButton
                                                      onClick={() =>
                                                        this.handleDownloadAISummary(
                                                          patient.patientId,
                                                        )
                                                      }
                                                      title="Download PDF"
                                                      style={{ padding: 6 }}
                                                    >
                                                      <img
                                                        src={DownloadIcon}
                                                        alt="Download"
                                                        style={{
                                                          width: 22,
                                                          height: 22,
                                                        }}
                                                      />
                                                    </IconButton>
                                                  </Box>
                                                ) : patient.patientEntity
                                                    ?.aiReferralSummaryStatus ===
                                                  "PENDING" ? (
                                                  <Box
                                                    style={{
                                                      padding: "4px 12px",
                                                      borderRadius: 12,
                                                      backgroundColor:
                                                        "#fff3cd",
                                                      color: "#856404",
                                                      fontSize: 10,
                                                      fontWeight: 500,
                                                      marginLeft: 5,
                                                    }}
                                                  >
                                                    Generating
                                                  </Box>
                                                ) : (
                                                  <Box
                                                    style={{
                                                      padding: "4px 12px",
                                                      borderRadius: 12,
                                                      backgroundColor:
                                                        "#e9ecef",
                                                      color: "#6c757d",
                                                      fontSize: 12,
                                                      fontWeight: 500,
                                                    }}
                                                  >
                                                    N/A
                                                  </Box>
                                                )}
                                              </Box>
                                            </Box>

                                            {/* Documents Section */}
                                            {patient.patientEntity
                                              .patientUploadHistory &&
                                              patient.patientEntity
                                                .patientUploadHistory.length >
                                                0 && (
                                                <Box style={{ marginTop: 16 }}>
                                                  <Box
                                                  // style={{
                                                  //   backgroundColor: "#f0f8f8",
                                                  //   borderRadius: 4,
                                                  //   padding: "16px",
                                                  // }}
                                                  >
                                                    <Box
                                                      style={{
                                                        backgroundColor:
                                                          "#51C1C0",
                                                        borderRadius: 25,
                                                        padding: "4px 16px",
                                                      }}
                                                    >
                                                      <Typography
                                                        variant="h6"
                                                        style={{
                                                          color: "#fff",
                                                          fontWeight: "bold",
                                                          fontSize: 16,
                                                          textTransform:
                                                            "capitalize",
                                                          marginBottom: 0,
                                                        }}
                                                      >
                                                        Documents
                                                      </Typography>
                                                    </Box>
                                                    <Box>
                                                      {patient.patientEntity.patientUploadHistory.map(
                                                        (document, index) => (
                                                          <Box
                                                            key={index}
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                            style={{
                                                              padding:
                                                                "2px 16px",
                                                              borderBottom:
                                                                index <
                                                                patient
                                                                  .patientEntity
                                                                  .patientUploadHistory
                                                                  .length -
                                                                  1
                                                                  ? "1px solid #C0C0C0"
                                                                  : "none",
                                                            }}
                                                          >
                                                            <img
                                                              src={FileIcon}
                                                              alt="File Icon"
                                                              style={{
                                                                marginRight: 8,
                                                              }}
                                                            />
                                                            <Typography
                                                              style={{
                                                                fontSize: 13,
                                                                color:
                                                                  "#2A2A2A",
                                                                flex: 1,
                                                              }}
                                                            >
                                                              {document.uploadName ||
                                                                `Document ${index +
                                                                  1}`}
                                                            </Typography>
                                                            <Box
                                                              display="flex"
                                                              gap={1}
                                                            >
                                                              <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                  this.handleViewDocument(
                                                                    document.uploadUrl,
                                                                    document.uploadName,
                                                                  )
                                                                }
                                                                disabled={
                                                                  this.state
                                                                    .loadingViewer
                                                                }
                                                                title="View"
                                                                style={{
                                                                  padding: 6,
                                                                }}
                                                              >
                                                                <img
                                                                  src={
                                                                    EyeIconGray
                                                                  }
                                                                  alt="View"
                                                                  style={{
                                                                    width: 25,
                                                                    height: 25,
                                                                  }}
                                                                />
                                                              </IconButton>
                                                              <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                  this.handleDownloadDocument(
                                                                    document.uploadUrl,
                                                                    document.uploadName,
                                                                  )
                                                                }
                                                                title="Download"
                                                                style={{
                                                                  padding: 6,
                                                                }}
                                                              >
                                                                <img
                                                                  src={
                                                                    DownloadIconGray
                                                                  }
                                                                  alt="Download"
                                                                  style={{
                                                                    width: 22,
                                                                    height: 22,
                                                                  }}
                                                                />
                                                              </IconButton>
                                                            </Box>
                                                          </Box>
                                                        ),
                                                      )}
                                                    </Box>
                                                  </Box>
                                                </Box>
                                              )}
                                          </>
                                        ) : (
                                          <Box
                                            style={{
                                              marginTop: 16,
                                              padding: "12px 16px",
                                              backgroundColor: "#fff3cd",
                                              borderRadius: 4,
                                            }}
                                          >
                                            <Typography
                                              style={{
                                                color: "#856404",
                                                fontSize: 14,
                                              }}
                                            >
                                              Access to patient documents and AI referral insights has expired for this referral (over 30 days since it was sent).
                                            </Typography>
                                          </Box>
                                        ))}
                                    </Box>
                                  ),
                                )}
                                {/* Transport work */}
                                {this.state.refferalTransportEntity && (
                                  <div>
                                    <Box className="Decline-Ref-Form">
                                      <div className="comment-info-box">
                                        <div className="comment-title">
                                          Comments to Potential Providers{" "}
                                        </div>
                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Pickup Date: 
                                          </div>
                                          <div className="comment-info-text">
                                            {moment
                                              .utc(
                                                this.state
                                                  .refferalTransportEntity
                                                  .transportDate,
                                              )
                                              // .add(offset, "minutes")
                                              .format("MM/DD/yyyy")}
                                          </div>
                                        </Box>
                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Pickup Time: 
                                          </div>
                                          <div className="comment-info-text">
                                            {
                                              this.state.refferalTransportEntity
                                                .transportPickupTime
                                            }
                                          </div>
                                        </Box>
                                        {this.state.refferalTransportEntity
                                          .transportPickUpAddress ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Pickup Address: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity
                                                  .transportPickUpAddress
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalTransportEntity
                                          .room ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Room: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity.room
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalTransportEntity
                                          .steFloor ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Floor: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity
                                                  .steFloor
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Drop off Address: 
                                          </div>
                                          <a
                                            href={`http://maps.google.com/maps?q=${this.state.refferalTransportEntity.transportDropLatitude},${this.state.refferalTransportEntity.transportDropLongitude}`}
                                            // eslint-disable-next-line react/jsx-no-target-blank
                                            target="_blank"
                                            className="comment-info-text"
                                          >
                                            {getFormattedAddress(
                                              this.state.refferalTransportEntity
                                                .transportDropMapObject,
                                            )}
                                          </a>
                                        </Box>
                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Needs: 
                                          </div>
                                          <div className="comment-info-text">
                                            {
                                              this.state.refferalTransportEntity
                                                .transportNeeds
                                            }
                                          </div>
                                        </Box>
                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Wait Time: 
                                          </div>
                                          <div className="comment-info-text">
                                            {
                                              this.state.refferalTransportEntity
                                                .waitTime
                                            }
                                          </div>
                                        </Box>

                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Companinon Needed
                                          </div>
                                          <div className="comment-info-text">
                                            {this.state.refferalTransportEntity
                                              .CompanionNeeded
                                              ? "Yes"
                                              : "No"}
                                          </div>
                                        </Box>

                                        {this.state.refferalTransportEntity
                                          .physicianToSee ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Physician to see: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity
                                                  .physicianToSee
                                              }
                                            </div>
                                          </Box>
                                        ) : null}
                                        {this.state.refferalTransportEntity
                                          .reasonForAppointment ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Reason for appointment: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity
                                                  .reasonForAppointment
                                              }
                                            </div>
                                          </Box>
                                        ) : null}
                                        {this.state.refferalTransportEntity
                                          .payor ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Payor: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity.payor
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalTransportEntity
                                          .comment ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Appointment details: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state
                                                  .refferalTransportEntity
                                                  .comment
                                              }
                                            </div>
                                          </Box>
                                        ) : null}
                                      </div>
                                    </Box>

                                    {/* {(selectedPatientData.refferalProviderEntity[0]
                                  .refferalProviderComment.length == 2 ||
                                  (this.state.prelimCommentByProvider != "" &&
                                    selectedPatientData.refferalId ==
                                      this.state.commentPostReferralId)) && (
                                  <div className="comment-info-box">
                                    <div className="comment-title">
                                      Comments to Potential Providers
                                    </div>

                                    <Box
                                      width={1}
                                      display="flex"
                                      flexDirection="row"
                                      mb={2}
                                      className="comment-info"
                                    >
                                      <div className="comment-info-user">
                                        Discharge User{" "}
                                      </div>
                                      <div className="comment-info-text">
                                        {selectedPatientData
                                          .refferalProviderEntity[0]
                                          .refferalProviderComment[0].sender ===
                                        "Discharge Planner"
                                          ? selectedPatientData
                                              .refferalProviderEntity[0]
                                              .refferalProviderComment[0].comment
                                          : selectedPatientData
                                              .refferalProviderEntity[0]
                                              .refferalProviderComment[1].comment}
                                      </div>
                                    </Box>
                                    <Box
                                      width={1}
                                      display="flex"
                                      flexDirection="row"
                                      mb={2}
                                      className="comment-info"
                                    >
                                      <div className="comment-info-user">
                                        Provider Response
                                      </div>
                                      <div className="comment-info-text">
                                        {selectedPatientData
                                          .refferalProviderEntity[0]
                                          .refferalProviderComment[1]
                                          ? selectedPatientData
                                              .refferalProviderEntity[0]
                                              .refferalProviderComment[1]
                                              .sender === "Provider User"
                                            ? selectedPatientData
                                                .refferalProviderEntity[0]
                                                .refferalProviderComment[1]
                                                .comment
                                            : selectedPatientData
                                                .refferalProviderEntity[0]
                                                .refferalProviderComment[0]
                                                .comment
                                          : this.state.prelimCommentByProvider}
                                      </div>
                                    </Box>
                                  </div>
                                )} */}
                                  </div>
                                )}

                                {/* Transport work */}

                                {/* DME work */}

                                {this.state.refferalDmeEntity && (
                                  <div>
                                    <Box className="Decline-Ref-Form">
                                      <div className="comment-info-box">
                                        <div className="comment-title">
                                          Comments to Potential Providers{" "}
                                        </div>

                                        {this.state.refferalDmeEntity
                                          .dmeHeight ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Height: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeHeight
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalDmeEntity
                                          .dmeWeight ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Weight: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeWeight
                                              }
                                            </div>
                                          </Box>
                                        ) : null}
                                        {this.state.refferalDmeEntity
                                          .dmePatientAddress ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Patient Address: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmePatientAddress
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalDmeEntity
                                          .dmeContactInformation ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Contact Information: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeContactInformation
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Estimate Discharge Date: 
                                          </div>
                                          <div className="comment-info-text">
                                            {moment
                                              .utc(
                                                this.state.refferalDmeEntity
                                                  .dmeEstimatestDischargeDate,
                                              )
                                              // .add(offset, "minutes")
                                              .format("MM/DD/yyyy")}
                                          </div>
                                        </Box>
                                        {this.state.refferalDmeEntity
                                          .dmeInsurance ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Insurance: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeInsurance
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalDmeEntity
                                          .dmeInsuranceMemebrId ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              InsuranceMemebr Id: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeInsuranceMemebrId
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalDmeEntity
                                          .dmeComments ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Comments: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeComments
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalDmeEntity
                                          .dmeEquipmentNeeds ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Equipment Needs: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeEquipmentNeeds
                                              }
                                            </div>
                                          </Box>
                                        ) : null}

                                        {this.state.refferalDmeEntity
                                          .dmeDiagonsis ? (
                                          <Box
                                            width={1}
                                            display="flex"
                                            flexDirection="row"
                                            mb={2}
                                            className="comment-info"
                                          >
                                            <div className="comment-info-user">
                                              Diagnosis and ICD-10 code: 
                                            </div>
                                            <div className="comment-info-text">
                                              {
                                                this.state.refferalDmeEntity
                                                  .dmeDiagonsis
                                              }
                                            </div>
                                          </Box>
                                        ) : null}
                                      </div>
                                    </Box>
                                  </div>
                                )}

                                {/* DME work */}
                                {selectedPatientData.refferalType == 1 && (
                                  <div>
                                    {/* { selectedPatientData.refferalProviderEntity[0]
                                    .refferalProviderComment.length &&
                                    selectedPatientData.refferalProviderEntity[0]
                                      .refferalProviderComment[0].comment &&
                                    selectedPatientData.refferalProviderEntity[0]
                                      .masterRefferalStatusEntity.id == 6 &&
                                    selectedPatientData.refferalProviderEntity[0]
                                      .refferalProviderComment.length == 1 &&
                                    (this.state.prelimCommentByProvider == "" ||
                                      selectedPatientData.refferalId !=
                                        this.state.commentPostReferralId) && ( */}
                                    {/* Comment box for Acknowledged (status 6) providers */}
                                    {selectedPatientData
                                      .refferalProviderEntity[0]
                                      .masterRefferalStatusEntity.id == 6 &&
                                      (this.state.prelimCommentByProvider ==
                                        "" &&
                                        this.state.selectedcomment == "" &&
                                        selectedPatientData.refferalId !=
                                          this.state.commentPostReferralId) && (
                                        <Box className="Decline-Ref-Form">
                                          {selectedPatientData
                                            .refferalProviderEntity[0]
                                            .refferalProviderComment.length ==
                                            1 &&
                                            selectedPatientData
                                              .refferalProviderEntity[0]
                                              .refferalProviderComment[0]
                                              .comment && (
                                              <div className="comment-info-box">
                                                <div className="comment-title">
                                                  Discharge planner comment{" "}
                                                </div>
                                                <Box
                                                  width={1}
                                                  display="flex"
                                                  flexDirection="row"
                                                  mb={2}
                                                  className="comment-info"
                                                >
                                                  <div className="comment-info-user">
                                                    Discharge User
                                                  </div>
                                                  <div className="comment-info-text">
                                                    {
                                                      selectedPatientData
                                                        .refferalProviderEntity[0]
                                                        .refferalProviderComment[0]
                                                        .comment
                                                    }
                                                  </div>
                                                </Box>
                                              </div>
                                            )}
                                          <form
                                            onSubmit={
                                              this.commentBoxModalSubmit
                                            }
                                          >
                                            <Box
                                              width={1}
                                              display="flex"
                                              flexDirection="column"
                                              alignItems="center"
                                            >
                                              <div
                                                className="comment-textbox "
                                                style={{ width: "100%" }}
                                              >
                                                <div className="comment-title">
                                                  Your comment to the discharge
                                                  planner. YOU MAY ONLY HAVE 1
                                                  COMMENT (If FINALIZED, you can
                                                  make ongoing comments). Make
                                                  it clear if you can accept the
                                                  patient. When ready, a
                                                  discharge planner based on the
                                                  family decision will either
                                                  FINALIZE that the referral is
                                                  yours to service or DROP the
                                                  referral from you. DROPPED
                                                  referrals no longer need your
                                                  assistance typically due to
                                                  family choice, another
                                                  provider accepted the referral
                                                  before you, or the service is
                                                  no longer needed.
                                                </div>
                                                <TextField
                                                  name="commentToDP"
                                                  value={this.state.commentToDP}
                                                  data-validators="isRequired"
                                                  multiline={true}
                                                  rows={3}
                                                  onChange={
                                                    this
                                                      .handleChangeInputForComment
                                                  }
                                                  className="Decline-TextField"
                                                />
                                              </div>

                                              <Button
                                                className="btn1 setbtnpos"
                                                type="submit"
                                                style={{ marginTop: "12px" }}
                                                disabled={
                                                  !this.validateForm() ||
                                                  this.state.loading
                                                }
                                              >
                                                {this.state.loading && (
                                                  <CircularProgress
                                                    size={24}
                                                    className="buttonProgress"
                                                  />
                                                )}
                                                Submit
                                              </Button>
                                            </Box>
                                            <div className="w-100">
                                              <FormErrors
                                                show={
                                                  !this.state.commentToDPValid
                                                }
                                                formErrors={
                                                  this.state.formErrors
                                                }
                                                fieldName="commentToDP"
                                              />
                                            </div>
                                          </form>
                                        </Box>
                                      )}
                                    {/* Show Can Accept status message */}
                                    {selectedPatientData
                                      .refferalProviderEntity[0]
                                      .masterRefferalStatusEntity.id == 9 && (
                                      <Box
                                        className="Decline-Ref-Form"
                                        style={{
                                          padding: "15px",
                                          textAlign: "center",
                                          backgroundColor: "#4caf50",
                                          borderRadius: "8px",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            color: "#fff",
                                            fontWeight: "bold",
                                            fontSize: 16,
                                          }}
                                        >
                                          You have indicated you can accept this
                                          patient.
                                        </div>
                                        <div
                                          style={{
                                            color: "rgba(255,255,255,0.85)",
                                            marginTop: 5,
                                          }}
                                        >
                                          Waiting for the discharge planner to
                                          finalize.
                                        </div>
                                      </Box>
                                    )}
                                    {/* Hide for Finalized (Status 3) and Pending Preliminary */}
                                    {selectedPatientData
                                      .refferalProviderEntity[0]
                                      .masterRefferalStatusEntity.id != 3 &&
                                      selectedPatientData
                                        .refferalProviderEntity[0]
                                        .masterRefferalStatusEntity
                                        .refferalStatusValue !== "Pending" &&
                                      (selectedPatientData
                                        .refferalProviderEntity[0]
                                        .refferalProviderComment.length >= 1 ||
                                        (this.state.prelimCommentByProvider !=
                                          "" &&
                                          selectedPatientData.refferalId ==
                                            this.state
                                              .commentPostReferralId)) && (
                                        <div className="comment-info-box">
                                          <div className="comment-title">
                                            Comments to Potential Providers
                                          </div>

                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Discharge User{" "}
                                          </div>
                                          <div className="comment-info-text">
                                            {selectedPatientData
                                              .refferalProviderEntity[0]
                                              .refferalProviderComment[0]
                                              .sender === "Discharge Planner"
                                              ? selectedPatientData
                                                  .refferalProviderEntity[0]
                                                  .refferalProviderComment[0]
                                                  .comment
                                              : selectedPatientData
                                                  .refferalProviderEntity[0]
                                                  .refferalProviderComment[1]
                                                  .comment}
                                          </div>
                                        </Box>
                                        <Box
                                          width={1}
                                          display="flex"
                                          flexDirection="row"
                                          mb={2}
                                          className="comment-info"
                                        >
                                          <div className="comment-info-user">
                                            Provider Response
                                          </div>
                                          <div className="comment-info-text">
                                            {selectedPatientData
                                              .refferalProviderEntity[0]
                                              .refferalProviderComment[1]
                                              ? (selectedPatientData
                                                  .refferalProviderEntity[0]
                                                  .refferalProviderComment[1]
                                                  .sender === "Provider" ||
                                                selectedPatientData
                                                  .refferalProviderEntity[0]
                                                  .refferalProviderComment[1]
                                                  .sender === "Provider User")
                                                ? selectedPatientData
                                                    .refferalProviderEntity[0]
                                                    .refferalProviderComment[1]
                                                    .comment
                                                : selectedPatientData
                                                    .refferalProviderEntity[0]
                                                    .refferalProviderComment[0]
                                                    .comment
                                              : this.state
                                                  .prelimCommentByProvider}
                                          </div>
                                        </Box>
                                        </div>
                                      )}
                                  </div>
                                )}

                                {/* Comments Section for FINALIZED referrals */}
                                {selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity.id == 3 && (
                                  <div className="comments-section PopComment NoMargin">
                                    <div className="comment-title">
                                      Comments -{" "}
                                      {selectedPatientData.categoryId &&
                                        this.state.categoryList.map((el) => {
                                          if (
                                            el.id ==
                                            selectedPatientData.categoryId
                                          ) {
                                            return el.categoryValue;
                                          }
                                        })}
                                    </div>
                                    {selectedPatientData
                                      .refferalPatientEntity[0] && (
                                      <Comment
                                        referralId={
                                          selectedPatientData.refferalId
                                        }
                                        receiverId={
                                          selectedPatientData
                                            .dischargeplannerEntity.id
                                            ? selectedPatientData
                                                .dischargeplannerEntity.id
                                            : ""
                                        }
                                        patientId={
                                          selectedPatientData
                                            .refferalPatientEntity[0].patientId
                                        }
                                        prelimComment={
                                          selectedPatientData.refferalProviderEntity &&
                                          selectedPatientData
                                            .refferalProviderEntity.length &&
                                          selectedPatientData
                                            .refferalProviderEntity[0]
                                            .refferalProviderComment &&
                                          selectedPatientData
                                            .refferalProviderEntity[0]
                                            .refferalProviderComment.length
                                            ? selectedPatientData
                                                .refferalProviderEntity[0]
                                                .refferalProviderComment
                                            : []
                                        }
                                      />
                                    )}
                                  </div>
                                )}

                                {selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity.id == 5 && (
                                  <Box className="Decline-Ref-Form">
                                    <TextField
                                      name="declineReason"
                                      value={
                                        selectedPatientData
                                          .refferalProviderEntity[0].comment
                                      }
                                      onChange={this.handleChangeInput}
                                      data-validators="isRequired"
                                      label="Decline Reason"
                                      disabled={true}
                                      multiline={true}
                                      rows={3}
                                      className="Decline-TextField g-text-field"
                                      style={{ margin: "0px 0px" }}
                                    />
                                    <div className="ref-text">
                                      By{" "}
                                      {
                                        selectedPatientData
                                          .refferalProviderEntity[0].provider
                                          .providerName
                                      }{" "}
                                      :
                                      {this.dateUtility.format(
                                        new Date(
                                          selectedPatientData.refferalProviderEntity[0].formattedUpdatedDateTime,
                                        ),
                                        "MM/dd/yyyy HH:mm:ss",
                                      )}
                                    </div>
                                  </Box>
                                )}
                              </Box>
                            ) : (
                              <Box
                                width={1}
                                display="flex"
                                flexDirection="column"
                                mb={2}
                              >
                                <div
                                  className={`list-item-content-Ref no-shadow`}
                                >
                                  No Patient found in referral.
                                </div>
                              </Box>
                            )}
                          </Scrollbars>
                        </div>
                        {this.state.referralStatusIds.includes(
                          selectedPatientData.refferalProviderEntity[0]
                            .masterRefferalStatusEntity.id,
                        ) ? (
                          <Box
                            display="flex"
                            flexDirection="row"
                            justifyContent="center"
                            width={1}
                            mb={3}
                            pt={0}
                            className="referral-right-actions"
                          >
                            {selectedPatientData.refferalType == 1 &&
                              selectedPatientData.refferalProviderEntity[0]
                                .masterRefferalStatusEntity.id == 6 && (
                                <>
                                  <Button
                                    className="btn3"
                                    onClick={this.canAcceptReferral}
                                  >
                                    Can Accept
                                  </Button>
                                  <Button
                                    className="btn5"
                                    onClick={this.refferalActionModalOpen}
                                  >
                                    Decline Referral
                                  </Button>
                                </>
                              )}

                            {selectedPatientData.refferalType == 0 &&
                              selectedPatientData.refferalProviderEntity[0]
                                .masterRefferalStatusEntity.id == 6 && (
                                <>
                                  <Button
                                    className="btn3"
                                    onClick={this.acceptedReferralModalOpen}
                                  >
                                    Accept Referral
                                  </Button>
                                  <Button
                                    className="btn5"
                                    onClick={this.refferalActionModalOpen}
                                  >
                                    Decline Referral
                                  </Button>
                                </>
                              )}

                            {selectedPatientData.refferalType == 1 &&
                              (selectedPatientData.refferalProviderEntity[0]
                                .masterRefferalStatusEntity.id != 5 &&
                                selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity.id != 6 &&
                                selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity.id != 7 &&
                                selectedPatientData.refferalProviderEntity[0]
                                  .masterRefferalStatusEntity.id != 9) && (
                                <Button
                                  className="btn5"
                                  onClick={this.refferalActionModalOpen}
                                >
                                  Decline Referral
                                </Button>
                              )}

                            {selectedPatientData.refferalProviderEntity[0]
                              .removeRefferal === true && (
                              <Button
                                className="btn3"
                                onClick={() =>
                                  this.confirmModalOpen(
                                    "Do you want to add the referral to dashboard?",
                                  )
                                }
                              >
                                {this.state.loading && (
                                  <CircularProgress
                                    size={24}
                                    className="buttonProgress"
                                  />
                                )}
                                Add Request to Dashboard
                              </Button>
                            )}

                            {selectedPatientData.refferalProviderEntity[0]
                              .removeRefferal === false && (
                              <Button
                                className="btn3"
                                onClick={() => {
                                  this.confirmModalOpen(
                                    "Do you want to remove the referral from dashboard?",
                                  );
                                  // After handling the modal, refresh the page
                                }}
                              >
                                {this.state.loading && (
                                  <CircularProgress
                                    size={24}
                                    className="buttonProgress"
                                  />
                                )}
                                Remove Request from Dashboard
                              </Button>
                            )}
                          </Box>
                        ) : (
                          <Box
                            display="flex"
                            flexDirection="row"
                            justifyContent="center"
                            width={1}
                            mb={3}
                            className="referral-right-actions"
                          >
                            <Button
                              className="btn3"
                              onClick={this.acceptedReferralModalOpen}
                            >
                              {selectedPatientData.refferalType == 1
                                ? "ACKNOWLEDGE RECEIPT"
                                : "Accept Referral"}
                            </Button>
                            <Button
                              className="btn5"
                              onClick={this.refferalActionModalOpen}
                            >
                              Decline Referral
                            </Button>
                          </Box>
                        )}
                      </div>
                    ) : this.state.loading ? (
                      <Box
                        display="flex"
                        justifyContent="center"
                        width={1}
                        className="ref-scrollbox"
                      >
                        <div className="select-referral-text">
                          Loading<br></br>
                          please wait...
                        </div>
                      </Box>
                    ) : (
                      <Box
                        display="flex"
                        justifyContent="center"
                        width={1}
                        className="ref-scrollbox"
                      >
                        <div className="select-referral-text">
                          Select Referral<br></br>
                          to View Details
                        </div>
                      </Box>
                    )}
                  </Box>
                  {/* Content viewer overlay for mobile - click to close */}
                  {this.state.mobileContentViewerOpen &&
                    this.state.mobileReferralPopupOpen && (
                      <div
                        className="content-viewer-overlay"
                        onClick={this.closeContentViewer}
                      />
                    )}
                  {/* Right side - Content Viewer */}
                  {/* On mobile: only render when mobileContentViewerOpen is true */}
                  {/* On desktop: render but control visibility with inline styles */}
                  {(window.innerWidth <= 767
                    ? this.state.mobileContentViewerOpen
                    : true) && (
                    <Box
                      className={`content-viewer-inside ${
                        this.state.contentViewerOpen ||
                        this.state.mobileContentViewerOpen
                          ? "viewer-open"
                          : ""
                      }`}
                      style={
                        window.innerWidth > 767
                          ? {
                              width: this.state.contentViewerOpen
                                ? window.innerWidth <= 1024 &&
                                  this.state.contentViewerOpen
                                  ? "100%"
                                  : "50%"
                                : "0%",
                              transition: "width 0.3s ease-in-out",
                              overflow: "hidden",
                              opacity: this.state.contentViewerOpen ? 1 : 0,
                            }
                          : {}
                      }
                    >
                      <ContentViewerPanel
                        open={
                          this.state.contentViewerOpen ||
                          this.state.mobileContentViewerOpen
                        }
                        onClose={this.closeContentViewer}
                        content={this.state.viewerContent}
                        contentType={this.state.viewerContentType}
                        fileName={this.state.viewerFileName}
                      />
                    </Box>
                  )}
                </div>
              </Box>
            </Box>
          </Box>
        ) : null}
      </div>
    );
  }
}

export const PatientList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientListClass);
export default PatientList;
